import { Buffer } from 'buffer';
import moment from "moment";
//localStorageDB
import localStorageDB from './localStorageDB.js';
import { ghepMenu } from './ghepMenu.js';
if(!window.ldb){
  window.ldb = localStorageDB();
}
const cachedData={};
// Dấu vết interceptor khoá tin cậy đã cắm (theo origin+khoá) — xem _installTrustKeyInterceptor.
const _trustInterceptorSigs = new Set();
//const cache_module={}
//import fetch from "isomorphic-fetch";
import axios from "axios";
//axios.defaults.withCredentials = true

import { saveAs } from "file-saver";
import isObject from "lodash/isObject";
import cloneDeep from "lodash/cloneDeep";
import isDate from "lodash/isDate";
//import  mapSeries from "async/mapSeries"
const list_not_require_id_app_default =[
  "user","users","domain","notification","message","listinfo","data_list_config","menuinfo","moduleinfo","reportinfo","tableinfo","labelinfo","rptobject",
  "trangthai","app","sysgroup","sysconfig","schedule","templatestore","reportconfig",
  "tinhthanh","quanhuyen","xaphuong","token","importexceltemplate","exportexceltemplate"
];
// Hàm helper để map MIME Type sang đuôi file
function getExtensionFromMime(mimeType) {
    if (!mimeType) return null;
    // Bỏ phần charset nếu có (vd: application/json; charset=utf-8)
    const type = mimeType.split(";")[0].trim();

    const mimeMap = {
        // Microsoft Office (Mới)
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": "pptx",
        
        // Microsoft Office (Cũ)
        "application/vnd.ms-excel": "xls",
        "application/msword": "doc",
        "application/vnd.ms-powerpoint": "ppt",

        // Tài liệu phổ biến
        "application/pdf": "pdf",
        "application/json": "json",
        "application/xml": "xml",
        "text/plain": "txt",
        "text/csv": "csv",

        // Ảnh
        "image/jpeg": "jpg",
        "image/png": "png",
        "image/gif": "gif",
        "image/svg+xml": "svg",
        "image/webp":"webp",

        // Nén
        "application/zip": "zip",
        "application/x-rar-compressed": "rar",
        "application/octet-stream": "bin" // Dạng nhị phân chung chung
    };

    return mimeMap[type] || null;
}

export default class APIs{
  constructor(config={}){
    if(!config.server_url_report) config.server_url_report = config.server_url;
    if(!config.list_not_require_id_app) config.list_not_require_id_app =[];
    this.config = config;
    this.config.get = (name)=>{
      return config[name];
    }
 
    this.list_not_require_id_app = [...list_not_require_id_app_default,...config.list_not_require_id_app];
    // Định tuyến list/CRUD qua /api/dispatch-list (server tự quyết định có/không /:id_app theo
    // require_id_app của controller). Đặt config.use_dispatch=false để dùng URL trực tiếp như cũ.
    this.use_dispatch = config.use_dispatch !== false;

    this.cachedData = cachedData;
    this.axios = axios;
    this.setCookie = this.setCookie.bind(this);
    this.getCookie = this.getCookie.bind(this);

    this.getLocalStore = this.getLocalStore.bind(this);
    this.get = this.get.bind(this);
    this.getLocal = this.getLocal.bind(this);
    this.asyncGet=this.asyncGet.bind(this);
    this.post = this.post.bind(this);
    this.asyncPost=this.asyncPost.bind(this);
    this.asyncDelete=this.asyncDelete.bind(this);
    this.asyncGetDataById=this.asyncGetDataById.bind(this);
    this.asyncGetData=this.asyncGetData.bind(this);
    this.asyncGetDataShared=this.asyncGetDataShared.bind(this);
    this.asyncGetList=this.asyncGetList.bind(this);
    this.asyncGetDataByIdShared=this.asyncGetDataByIdShared.bind(this);
    this.asyncGetListShared=this.asyncGetListShared.bind(this);
    this.asyncPostList=this.asyncPostList.bind(this);
    this.asyncDeleteList=this.asyncDeleteList.bind(this);
    this.asyncGetReport=this.asyncGetReport.bind(this);
    this.asyncFiles=this.asyncFiles.bind(this);
    this.asyncGetLogById=this.asyncGetLogById.bind(this);

    // ── XÁC THỰC MỚI: JWT ngắn hạn + refresh xoay vòng + PAT (xem khối "XÁC THỰC" bên dưới) ──
    this.setTokens=this.setTokens.bind(this);
    this.clearTokens=this.clearTokens.bind(this);
    this.getAccessToken=this.getAccessToken.bind(this);
    this.getRefreshToken=this.getRefreshToken.bind(this);
    this.onAuthChange=this.onAuthChange.bind(this);
    this.onSessionExpired=this.onSessionExpired.bind(this);
    this.asyncRefreshToken=this.asyncRefreshToken.bind(this);
    this.asyncAuthMe=this.asyncAuthMe.bind(this);
    this.asyncLogoutAll=this.asyncLogoutAll.bind(this);
    this.asyncGetPats=this.asyncGetPats.bind(this);
    this.asyncCreatePat=this.asyncCreatePat.bind(this);
    this.asyncUpdatePat=this.asyncUpdatePat.bind(this);
    this.asyncRevokePat=this.asyncRevokePat.bind(this);
    this.asyncDeletePat=this.asyncDeletePat.bind(this);
    this.asyncRotatePat=this.asyncRotatePat.bind(this);
    this.asyncGetSessions=this.asyncGetSessions.bind(this);
    this.asyncRevokeSession=this.asyncRevokeSession.bind(this);
    this.asyncRevokeOtherSessions=this.asyncRevokeOtherSessions.bind(this);
    this._auth = this._loadAuth();
    this._authListeners = [];
    this._sessionListeners = [];
    this._sessionDead = false;   // đã báo "phiên chết" chưa (chỉ báo 1 lần cho tới khi đăng nhập lại)
    this._refreshing = null;
    this._installAuthInterceptor();
    // Gắn khoá tin cậy cho MỌI request đi tới máy chủ của mình (xem _installTrustKeyInterceptor).
    this._installTrustKeyInterceptor();
    this.withTrustKey = this.withTrustKey.bind(this);

    this.loginAPI=this.loginAPI.bind(this);
    this.asyncLoginAPI=this.asyncLoginAPI.bind(this);
    this.logoutAPI=this.logoutAPI.bind(this);
    this.asyncLoginSms=this.asyncLoginSms.bind(this);
    this.asyncLoginSmsVerify=this.asyncLoginSmsVerify.bind(this);

    this.asyncLogoutAPI=this.asyncLogoutAPI.bind(this);
    this.asyncSign=this.asyncSign.bind(this);
    this.signup=this.signup.bind(this);
    this.asyncSignup=this.asyncSignup.bind(this);
    this.asyncResetPassword=this.asyncResetPassword.bind(this);
    this.asyncChangePasswordByAdmin=this.asyncChangePasswordByAdmin.bind(this);
    this.asyncChangePassword=this.asyncChangePassword.bind(this);
    this.getUserInfoByToken=this.getUserInfoByToken.bind(this);
    this.asyncGetUserInfoByToken=this.asyncGetUserInfoByToken.bind(this);
    this.asyncGetProfile=this.asyncGetProfile.bind(this);

    this.asyncJoinApp=this.asyncJoinApp.bind(this);
    this.asyncGetAppInfo=this.asyncGetAppInfo.bind(this);
    this.asyncGetFeatures=this.asyncGetFeatures.bind(this);
    this.hasFeature=this.hasFeature.bind(this);
    this.featurePackage=this.featurePackage.bind(this);
    this.featuresLoaded=this.featuresLoaded.bind(this);
    this.asyncBackup=this.asyncBackup.bind(this);
    this.asyncRestore=this.asyncRestore.bind(this);

    this.getWalletByAddress=this.getWalletByAddress.bind(this);
    this.getLanguage=this.getLanguage.bind(this);
    this.getLabel=this.getLabel.bind(this);
    this.createLabel=this.createLabel.bind(this);
    this.getLabelsList=this.getLabelsList.bind(this);
    this.asyncCountShared=this.asyncCountShared.bind(this);
    this.asyncLoadLang=this.asyncLoadLang.bind(this);
    this.asyncSetLang=this.asyncSetLang.bind(this);
    this.asyncGetCustomerByEmail=this.asyncGetCustomerByEmail.bind(this);
    this.asyncGetPaymentMethods=this.asyncGetPaymentMethods.bind(this);
    this.downloadFile=this.downloadFile.bind(this);
    this.asyncDownloadReportWithTemplate=this.asyncDownloadReportWithTemplate.bind(this);
    this.asyncDownloadVoucherWithTemplate=this.asyncDownloadVoucherWithTemplate.bind(this);

    this.uploadSingleFile=this.uploadSingleFile.bind(this);
    this.uploadFile=this.uploadFile.bind(this);
    this.asyncGetModules=this.asyncGetModules.bind(this);
    this.asyncGetMenu=this.asyncGetMenu.bind(this);
    this.asyncUpdateRight=this.asyncUpdateRight.bind(this);
    this.addNotifySchedule=this.addNotifySchedule.bind(this);
    this.deleteNotifySchedule=this.deleteNotifySchedule.bind(this);
    this.addSchedule=this.addSchedule.bind(this);
    this.deleteSchedule=this.deleteSchedule.bind(this);
    this.asyncTinhChietKhauHD=this.asyncTinhChietKhauHD.bind(this);
    this.getPromotion = this.getPromotion.bind(this);
    this.preload = this.preload.bind(this);
    this.savePreLoadKey = this.savePreLoadKey.bind(this);
    this.getPreLoadList = this.getPreLoadList.bind(this);
    this.aiChat = this.aiChat.bind(this);
    this.aiChatAsync = this.aiChatAsync.bind(this);
    this.aiTaskStatus = this.aiTaskStatus.bind(this);
    this.aiTaskRetry = this.aiTaskRetry.bind(this);
    this.chamcong = this.chamcong.bind(this);
    this.preloadLists={};
    this.lang= "vi"
  }
 
  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  getLocalStore(){
    return window.ldb;
  }
  convertModel(model_name){
    if(model_name==="dmtk") model_name ="account";
    if(model_name==="dmkh") model_name ="customer";
    if(model_name==="dmnt") model_name ="currency";
    return model_name;
  }
  /**
   * Dựng URL DANH SÁCH & CRUD. Mặc định đi qua /api/dispatch-list để SERVER tự quyết định
   * có/không /:id_app theo require_id_app của controller — client gửi id_app "thừa" cũng không
   * sao (server tự bỏ cho model dùng chung). Đặt config.use_dispatch=false để dùng URL trực tiếp.
   * @param {string} model_name  api code
   * @param {string} _id_app     id_app (chuỗi rỗng = không kèm)
   * @param {string} [sub]       phần path sau model: 'search' | '<id>' | 'action/delete' | 'g/history/<id>'...
   */
  listBaseUrl(model_name,_id_app,sub){
    const base = this.config.get("server_url_report");
    const idPart = _id_app ? `${_id_app}/` : "";
    const subPart = sub ? `/${sub}` : "";
    if(this.use_dispatch === false){
      // Tương thích ngược: URL trực tiếp (tìm kiếm dùng prefix /search).
      if(sub === "search") return `${base}/api/search/${idPart}${model_name}`;
      return `${base}/api/${idPart}${model_name}${subPart}`;
    }
    // dispatch-list: /search là sub 'search' ở cuối, server tự đưa lên prefix.
    return `${base}/api/dispatch-list/${idPart}${model_name}${subPart}`;
  }
  async getPreLoadList(id_app,token){
    let key = `required-preload-${id_app}-${token}-v2`;
    if(this.preloadLists[key]) return {preloadList:this.preloadLists[key],key};
    let self = this;
    return new Promise((resolve)=>{
      window.ldb.getItem(key,(error,preloadList)=>{
        if(preloadList){
          if(typeof(preloadList)!=="object"){
            try{
              preloadList = JSON.parse(preloadList);
            }catch(e){
              preloadList = undefined;
            }
          }
        }
        if(!preloadList){
          preloadList = [];
        }
        self.preloadLists[key] = preloadList;
        resolve({preloadList,key})
      })
    })
  }
  async preload(id_app,token){
    /*let {preloadList,key} = await this.getPreLoadList(id_app,token);
    mapSeries(preloadList,async (r)=>{
      if(r.url){
        let url = r.url;
        await new Promise(resolve=>{
          setTimeout(()=>{
            this.get(url,null,(error,rs)=>{
              if(error){
                console.error("can't preload",url,error);
                return resolve()
              }
              setTimeout(()=>{
                ldb.setItem(url,(typeof(rs)=="object"?JSON.stringify(rs):rs),e=>{
                  if(e){
                    console.error("error preload",e);
                  }
                  //console.log("data preloaded",url);
                  resolve()
                },r.cache_key);
              },0)
            },{cache:false});
          },300)
        })
      }
    },(e)=>{
      if(e) return console.error("error preload data",e);
      console.log("preload data completed");
    })
    */
  }
  async savePreLoadKey(id_app,token,url,options={}){
    let {preloadList,key} = await this.getPreLoadList(id_app,token);
    if(!preloadList.find(r=>r.url===url && r.cache_key===options.cache_key)){
      preloadList.push({url,cache_key:options.cache_key});
      //console.log("save preload",preloadList);
      window.ldb.setItem(key,JSON.stringify(preloadList),e=>{
        if(e){
          console.error("error save preload list",e);
        }
      });
    }
  }
  getLocal(url,headers,callback,options={}){
    //let data = localStorage.getItem(url);
    let cache_key = options.cache_key;
    window.ldb.getItem(url,(error,data)=>{
      if(data){
        //console.log("get from local",url);
        if(options.stringifyData==false && typeof(data)!=="object"){
          try{
            data = JSON.parse(data);
          }catch(e){
            console.error(e,data);
            data = undefined;
          }
        }
        //chi cache neu data la mot mang co it nhat mot gia tri
        if(typeof(data)=="object" && data.length && data.length==0){
          data = undefined;
        }
        //
        this.get(url,headers,(error,rs,response)=>{
          if(error){
            if(data===undefined){
              callback(error);
              if(options.onlineCallback){
                options.onlineCallback(error);
              }
            }
            return console.error(error);
          }
          if(options.onlineCallback){
            options.onlineCallback(null,rs,response);
          }
          setTimeout(()=>{
            window.ldb.setItem(url,(typeof(rs)=="object"?JSON.stringify(rs):rs),e=>{
              if(e){
                window.ldb.removeItem(url,null,cache_key);
                console.error(e);
              }
            },cache_key);
            if(data===undefined){ 
              callback(null,rs);
            }
          },0)
  
        },{cache:false,stringifyData:options.stringifyData});
  
        if(data!=undefined){
          callback(null,data);
        }
        
      }else{
        //console.log("get from server",url);
        this.get(url,headers,(error,rs)=>{
          if(error) return callback(error);
          setTimeout(()=>{
            //console.log("save to local");
            window.ldb.setItem(url, (typeof(rs)=="object"?JSON.stringify(rs):rs),e=>{
              if(e){
                window.ldb.removeItem(url,null,cache_key);
                console.error(e);
              }
              
            },cache_key);
          },0)
          callback(null,rs);
        },{cache:false,stringifyData:options.stringifyData})
      }
    },cache_key);
  }
  get(url,headers,callback,options={cache:false,stringifyData:true,withCredentials:true}){
    let cache_key = url;
    //required refresh
    if(options.refresh){
      if(url.indexOf("?")<0){
        url = url + "?refresh_required=" + true;
      }else{
        url = url + "&refresh_required=" + true;
      }
    }
    //let _headers ={"Accept-Encoding":"gzip"};
    let _headers ={};
    Object.assign(_headers, this._trustHeaders());
    if(headers){
      if(Array.isArray(headers)){
        headers.forEach(h=>{
          _headers[h.name] = h.value;
        })
      }else{
        _headers = Object.assign(_headers,headers)
      }
    }
    if(options.withCredentials==undefined) options.withCredentials = true;
    //console.log("[get] headers",_headers);

    if(options.cache && !options.refresh && cachedData[cache_key] && cachedData[cache_key]!="[]"  && cachedData[cache_key]!="{}"){
      let text = cachedData[cache_key];
      //console.log("get from cache",options,cache_key)
      if(options.stringifyData===false && typeof(text)!="object"){
        try{
          text = JSON.parse(text);
        }catch(e){
          console.error(e,text);
        }
      }
      callback(null,text);
      //get from server
      axios.get(url,{withCredentials: options.withCredentials,headers: _headers}).then(response=>{
        if(options.stringifyData==false){
          cachedData[cache_key] = response.data;
        }else{
          cachedData[cache_key] = (typeof(response.data)==="object"?JSON.stringify(response.data):response.data);
        }
        if(options.onlineCallback){
          let text = (options.stringifyData!=false && typeof(response.data)==="object"?JSON.stringify(response.data):response.data)
          
          options.onlineCallback(null,text,{url,data:response.data})
        }
      }).catch(e=>{
        let error = (e.response?e.response.data:e) || e
        console.error("Error get data:",error);
        if(options.onlineCallback){
          options.onlineCallback(error)
        }
      })
    }else{
      //console.log("getting from server",url,options)
      axios.get(url,{withCredentials: options.withCredentials,headers: _headers}).then(response=>{
        //console.log("get from server",url,options)
        let text = (options.stringifyData!=false && typeof(response.data)==="object"?JSON.stringify(response.data):response.data)
        callback(null,text,{url,data:response.data});
        if(options.cache){
          if(options.stringifyData==false){
            cachedData[cache_key] = response.data;
          }else{
            cachedData[cache_key] = (typeof(response.data)==="object"?JSON.stringify(response.data):response.data);
          }
        } 
      }).catch(e=>{
        let error = (e.response?e.response.data:e) || e
        //console.error("Error get data:",error);
        callback(error);
      })
    }
  }
  async post(url,headers,data,callback,method="POST",options={stringifyData:true,withCredentials:true}){
    
    if(options.withCredentials==undefined && url.indexOf(this.config.get("server_url")>=0)) options.withCredentials = true;
    let _headers={};
    _headers['Content-Type']= 'application/json';
    Object.assign(_headers, this._trustHeaders());
    //_headers['Content-Encoding']= 'deflate';
    if(headers){
      if(Array.isArray(headers)){
        headers.forEach(h=>{
          _headers[h.name] = h.value;
        })
      }else{
        _headers = Object.assign(_headers,headers)
      }
    }
    /*if(!cache_module.zipLib){
      const {default:pako} = await import("pako");
      cache_module.zipLib = pako;
    } 
    let zippedData = cache_module.zipLib.deflate(JSON.stringify(data));*/
    //console.log("[post] headers",_headers);
    axios({
      method: method.toLowerCase(),
      url: url,
      data: data,
      //data: zippedData,
      withCredentials: options.withCredentials,
      headers: _headers
    }).then(response=>{
      //console.log(options.stringifyData,response.data);
      let text = (options.stringifyData!=false && typeof(response.data)==="object"?JSON.stringify(response.data):response.data)
      callback(null,text,response);
    }).catch(e=>{
      let error = (e.response?e.response.data:e) || e
      //console.error("Error get data:",error);
      callback(error);
    })
  }
  deleteRequest(url,headers,callback,options={stringifyData:true}){
    if(options.withCredentials==undefined) options.withCredentials = true;
    let _headers={};
    Object.assign(_headers, this._trustHeaders());
    if(headers){
      if(Array.isArray(headers)){
        headers.forEach(h=>{
          _headers[h.name] = h.value;
        })
      }else{
        _headers = Object.assign(_headers,headers)
      }
    }
    //console.log("[delete] headers",_headers);
    axios({
      method: "delete",
      url: url,
      withCredentials: options.withCredentials,
      headers: _headers
    }).then(response=>{
      let text = (options.stringifyData!=false && typeof(response.data)==="object" ?JSON.stringify(response.data):response.data)
      callback(null,text,response);
    }).catch(e=>{
      let error = (e.response?e.response.data:e) || e
      //console.error("Error get data:",error);
      callback(error);
    })
  }

  async asyncGet(url,headers,options={}){
    let p = new Promise((resovle,reject)=>{
      if(options.cache_local && !options.refresh){
        this.getLocal(url,headers,(e,rs)=>{
          if(e) return reject(e);
          resovle(rs);
        },options)
      }else{
        this.get(url,headers,(e,rs)=>{
          if(e) return reject(e);
          resovle(rs);
        },options)
      }
      
    })
    return p;
  }

  async asyncGetList(access_token,model_name,options={}){
    options.stringifyData = false;
    model_name = this.convertModel(model_name);
    if(typeof(model_name)=="object"){
      console.error("[asyncGetList] api code không thể là một Object",model_name);
      throw "Api code phải là một chuỗi";
    }
    let _id_app =(options.require_id_app==false || this.list_not_require_id_app.indexOf(model_name)>=0)?"":(options.id_app || (options.condition||{}).id_app ||this.config.get("id_app"));

    let rs,url;
    if((options.cache || options.cache_local || !_id_app) && !(options.type_data=="xlsx" || options.type_data=="json_export" || options.type_data=="json_file") ){
      url = `${this.listBaseUrl(model_name,_id_app)}?page=${options.page||1}&access_token=${access_token}`;
      if(options.query_string)url = `${url}&${options.query_string}`;
      if(options.buildUrl){
        url = options.buildUrl(url);
      }

      if(options.sort) url = `${url}&sort=${typeof(options.sort)=="object"?JSON.stringify(options.sort):options.sort}`
      if(options.condition && Object.keys(options.condition).length>0){
        url = `${url}&q=${JSON.stringify(options.condition)}`
      } 
      if(options.fields)url = `${url}&fields=${options.fields}`;
      if(options.limit)url = `${url}&limit=${options.limit}`;
      if(options.pagination)url = `${url}&pagination=${options.pagination}`;

      if(options.notfields)url = `${url}&notfields=${options.notfields}`;
      if(options.count)url = `${url}&count=1`;
      // Nhánh GET cũng phải gửi listinfo-code (nhánh POST đã có trong body) — server tra quyền theo mã này,
      // thiếu là server dùng mã API gốc và user thường có thể bị trả [] dù có quyền với listinfo đang dùng.
      if(options["listinfo-code"]) url = `${url}&listinfo-code=${encodeURIComponent(options["listinfo-code"])}`;
      if(options.log){
        options.log("fetch: " + url);
      }
      rs =  await this.asyncGet(url,options.headers,options);
      if(options.cache_local && access_token && _id_app && rs && rs.length>5){//Chỉ cache các kết quả có số lượng phần tử >5
        this.savePreLoadKey(_id_app,access_token,url,options)
      }
    }else{
      url = `${this.listBaseUrl(model_name,_id_app,'search')}?access_token=${access_token}`;
      if(options.query_string)url = `${url}&${options.query_string}`;
      if(options.buildUrl){
        url = options.buildUrl(url);
      }
      if(options.log){
        options.log("fetch: " + url);
      }
      let body ={...options};

      if(options.condition) body.q = body.condition;
      delete body.condition;

      if(!options.count)
        body.page = body.page || 1;
      else{
        delete body.fields;
        delete body.notfields;
        delete body.page;
        body.count = 1;
      }
      delete body.query_string;
      delete body.buildUrl;
      delete body.log;
      delete body.cache_local;
      delete body.cache;
      delete body.preload;

      
      

      if(options.type_data=="xlsx" || options.type_data=="json_export" || options.type_data=="json_file"){
        url = `${url}&type_data=${options.type_data}&limit=1000000000`
      }

      rs =  await this.asyncPost(url,options.headers,body,"POST","GETLIST",false,{stringifyData:false});
    }
    if(!rs) return []
    try{
      if(!options.fields && !options.count && Array.isArray(rs)){
        rs.forEach(r=>{
          r.is_full_data = true;
        })
      }
      return rs;
    }catch(e){
      console.error(e,rs,url,options);
      throw e;
    }
  }
  
  async asyncPost(url,headers,data,method="POST",action="POST",require_recaptcha=true,options={}){
    //console.log("asyncpost",options);
    const config = this.config;
    const post = this.post;
    return new Promise((resolve,reject)=>{
      if(config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha!=='undefined' && require_recaptcha){
        grecaptcha.ready(function() {
          grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {action: action})
          .then(function(token) {
            data["g-recaptcha-response"]  = token;
            post(url,headers,data,(e,rs)=>{
              if(e) return reject(e);
              resolve(rs);
            },method,options)
          },function(e){
            reject({message:e||"Lỗi khi tải google recaptcha",code:400})
          });
        });
      }else{
        //console.time(`${method}: ${url}`);
        post(url,headers,data,(e,rs)=>{
          if(e) return reject(e);
          //console.timeEnd(`${method}: ${url}`);
          resolve(rs);
        },method,options)
      }
    })
  }
  async chamcong(access_token,user){
    const condition ={device_user_id:user,ngay:{
      $gte:moment().startOf("day").toDate(),
      $lte:moment().endOf("day").toDate()
    }}
    let checkins = await this.asyncGetList(access_token,"chamcong",{
      condition,
      sort:{ngay:1},
      headers:{
        "listinfo-code":"chamcong_agent"
      }
    });
    console.log("[lay cham cong]",condition,checkins)
    let {gio_vao,gio_ra} = checkins[0]||{};
    return {gio_vao,gio_ra};
  }
  async aiChat(access_token,{id_app,session_id, message,files}){
    let _id_app =id_app ||this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/chat_session/message`;
    let method ="POST";
    url = `${url}?access_token=${access_token}`;
    let rs =  await this.asyncPost(url,null,{session_id, message,files},method,method,false);
    return JSON.parse(rs);
  }
  // Gửi yêu cầu AI CHẠY NỀN (cho tác vụ nặng) -> trả { success, data:{ task_id, status } } NGAY.
  async aiChatAsync(access_token,{id_app,session_id, message,files}){
    let _id_app = id_app || this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/chat_session/message/async?access_token=${access_token}`;
    let rs = await this.asyncPost(url,null,{session_id, message,files},"POST","POST",false);
    return JSON.parse(rs);
  }
  // Poll TRẠNG THÁI + kết quả 1 tác vụ nền.
  async aiTaskStatus(access_token,task_id,{id_app}={}){
    let _id_app = id_app || this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/chat_session/task/${task_id}?access_token=${access_token}`;
    let rs = await this.asyncGet(url,null,{stringifyData:false});
    return typeof rs === "string" ? JSON.parse(rs) : rs;
  }
  // RETRY 1 tác vụ nền bị lỗi (tiếp tục từ chỗ dở nhờ checkpoint).
  async aiTaskRetry(access_token,task_id,{id_app}={}){
    let _id_app = id_app || this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/chat_session/task/${task_id}/retry?access_token=${access_token}`;
    let rs = await this.asyncPost(url,null,{},"POST","POST",false);
    return JSON.parse(rs);
  }
  async asyncPostList(access_token,model_name,datas,options={}){
    options.stringifyData = false;
    model_name = this.convertModel(model_name);
    if(!Array.isArray(datas)){
      datas =[datas]
    }
    let result=[]
    //POST
    let datas_post = datas.filter(d=>!d._id);
    if(datas_post.length>0){
      let _id_app =(options.require_id_app==false || this.list_not_require_id_app.indexOf(model_name)>=0)?"":(options.id_app || datas_post[0].id_app ||this.config.get("id_app"));
      let url = this.listBaseUrl(model_name,_id_app);
      let method ="POST";
      url = `${url}?access_token=${access_token}`;
      const rs =  await this.asyncPost(url,options.headers,datas_post,method,method,false,options);
      result = [...result,...rs]
    }
    //PUT
    let datas_put = datas.filter(d=>d._id);
    for(let data of datas_put){
      let _id_app =(options.require_id_app==false || this.list_not_require_id_app.indexOf(model_name)>=0)?"":(options.id_app || data.id_app ||this.config.get("id_app"));
      let url = this.listBaseUrl(model_name,_id_app,data._id);
      let method ="PUT";
      url = `${url}?access_token=${access_token}`;
      //console.log("[asyncPostList] put",data);
      const rs =  await this.asyncPost(url,options.headers,data,method,method,false,options);
      result.push(rs);
    }
    //Trả lại kết quả
    setTimeout(()=>{
      for(let key in cachedData){
        if(key.indexOf(model_name)>=0) delete  cachedData[key];
      }
    },0)
    return datas.length==1?result[0]:datas;
    
  }

  async asyncDeleteList(access_token,model_name,_id,options={}){
    setTimeout(()=>{
      for(let key in cachedData){
        if(key.indexOf(model_name)>=0) delete  cachedData[key];
      }
    },0)
    model_name = this.convertModel(model_name);
    let _id_app =(options.require_id_app==false || this.list_not_require_id_app.indexOf(model_name)>=0)?"":(options.id_app||this.config.get("id_app"));
    let url = this.listBaseUrl(model_name,_id_app,_id);
    url = `${url}?access_token=${access_token}`

    if(options.otp_id)url = `${url}&otp-id=${options.otp_id}`;
    if(options.otp_code)url = `${url}&otp-code=${options.otp_code}`;

    return await this.asyncDelete(url,options.headers);
  }
  async asyncGetListShared(access_token,model_name,options={}){
    options.stringifyData = false;
    model_name = this.convertModel(model_name);
    //if(!options.notfields) options.notfields = 'exfields,mieu_ta,mieu_ta_goc,mieu_ta_en,mieu_ta_goc_en';
    let url = `${this.config.get("server_url_report")}/api/${model_name}/shared?page=${options.page||1}&access_token=${access_token}`;
    if(options.sort) url = `${url}&sort=${JSON.stringify(options.sort)}`
    if(options.condition && Object.keys(options.condition).length>0) url = `${url}&q=${JSON.stringify(options.condition)}`
    if(options.limit)url = `${url}&limit=${options.limit}`;
    if(options.fields)url = `${url}&fields=${options.fields}`;
    if(options.notfields)url = `${url}&notfields=${options.notfields}`;
    if(options.count)url = `${url}&count=1`;

    

    if(options.log){
      options.log("fetch: " + url);
    }

    let rs = await this.asyncGet(url,null,options);
    return rs;
  }
  async asyncGetDataById(access_token,model_name,id,_id_app,options={}){
    options.stringifyData = false;
    if(!_id_app) _id_app = this.config.get("id_app");
    model_name = this.convertModel(model_name);
    _id_app =(options.require_id_app==false || this.list_not_require_id_app.indexOf(model_name)>=0)?"":_id_app;
    let url = `${this.listBaseUrl(model_name,_id_app,id)}?access_token=${access_token}`;
    let rs = await this.asyncGet(url,undefined,options);
    return rs;
  }
  async asyncGetDataByIdShared(access_token,model_name,id,options={}){
    options.stringifyData = false;
    model_name = this.convertModel(model_name);

    let url = `${this.config.get("server_url_report")}/api/${model_name}/shared/${id}?access_token=${access_token}`;
    let rs = await this.asyncGet(url,undefined,options);
    return rs;
  }

  async asyncGetData(access_token,model_name,condition,field,cache=false,cache_local=false,options={}){
    const _options = {require_id_app:options.require_id_app,id_app:options.id_app || (condition||{}).id_app,condition:condition,fields:field,cache:cache,cache_local:cache_local,notfields:"__v"};
    // Chuyển tiếp listinfo-code: lấy chi tiết 1 bản ghi phải tra quyền theo CÙNG mã với lúc tải danh sách.
    if(options["listinfo-code"]) _options["listinfo-code"] = options["listinfo-code"];
    let rs = await this.asyncGetList(access_token,model_name,_options);
    if(rs.length>0){
      return field?rs[0][field]:rs[0];
    }else{
      return null;
    }
  }
  async asyncGetDataShared(access_token,model_name,condition){
    let rs = await this.asyncGetListShared(access_token,model_name,{condition:condition});
    if(rs.length>0){
      return rs[0];
    }else{
      return null;
    }
  }

  async asyncGetLogById(access_token,model_name,id,_id_app,options={}){
    options.stringifyData = false;
    if(!_id_app) _id_app = this.config.get("id_app");
    model_name = this.convertModel(model_name);
    _id_app =(options.require_id_app==false ||this.list_not_require_id_app.indexOf(model_name)>=0)?"":_id_app;
    let url = `${this.listBaseUrl(model_name,_id_app,`g/history/${id}`)}?access_token=${access_token}`;
    let rs = await this.asyncGet(url,undefined,options);
    return rs;
  }
  
  async asyncDelete(url,headers){
    let p = new Promise((resovle,reject)=>{
      this.deleteRequest(url,headers,(e,rs)=>{
        if(e) return reject(e);
        resovle(rs);
      })
    })
    return p;
  }

  async asyncFiles(access_token,id_link,_id_app="",_condition={},limit=0){
    let condition ={
      id_link:id_link
    }
    condition = Object.assign(condition,_condition);
    if(!_id_app) _id_app = this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/file?q=${JSON.stringify(condition)}&access_token=${access_token}`;
    if(limit) url = url + "&limit=" + limit.toString();
    let files = await this.asyncGet(url,null,{cache:true,stringifyData:false});
    return files;
  }
  //labels management
  async getLabelsList(){
    let public_token = this.config.get("public_token");
    if(!public_token){
      this.labels ={}
      return this.labels;
    }
    let condition={
      labelid:this.config.get("app_code")
    }
    let self = this;
    console.time("load label list");
    let url = `${this.config.get("server_url_report")}/api/labelinfo?access_token=${public_token}&limit=10000&q=${JSON.stringify(condition)}`;
    try{
      let _rs = await this.asyncGet(url,null,{cache_local:true,cache:true,stringifyData:false,onlineCallback:(e,rs)=>{
        if(rs){
          //console.log("online labels",_rs)
          self.labels = self.labels|| {};
          rs.forEach(r=>{
            self.labels[r.textid] = r;
          })
        }
      }});
      this.labels ={}
      _rs.forEach(r=>{
        this.labels[r.textid] = r;
      })
      //console.log("local labels",_rs)
    }catch(e){
      console.error("can't get labels list",e);
    }
    console.timeEnd("load label list");
    return this.labels;
  }
  async createLabel(condition){
    if(this.userInfo && !this.userInfo.admin) return;
    if(!this.labels) return;
    if(!condition.textv || (condition.textv.indexOf("<")>=0 || condition.textv.length>256)){
      return 
    }
    let token = localStorage.getItem("token");
    if(!token || token===this.config.get("public_token")){
      return;
    }
    let url = `${this.config.get("server_url_report")}/api/labelinfo?access_token=${token}`;
    try{
      console.log("create new label:",condition.textv);
      await this.asyncPost(url,null,condition,"POST","createLabel");
      this.labels[condition.textid] = condition;
    }catch(e){
      //console.error("can't create default label",e,condition.textid);
    }
  }
  asyncLoadLang(){
    try{
      this.lang = localStorage.getItem("lang");
      if(!this.lang){
        this.lang ="vi";
      }
    }catch(e){
      this.lang ="vi";
    }
    return this.lang;
  }
  asyncSetLang(ngon_ngu){
    this.lang =ngon_ngu;
    try{
      localStorage.setItem("lang",ngon_ngu);
    }catch(e){
      if(e) console.error(e);
    }
  }
  getLanguage(){
    return this.lang;
  }
  getLabel(textid,defaultv='',defaulte='',lang=''){
    if(!textid) return "";
    textid = textid.toString();
    let _default,field;
    if(!lang) lang = this.getLanguage();
    switch(lang){
      case "vi":{
        _default = defaultv||defaulte||textid;
        field = "textv";
        break;
      }
      case "en":{
        _default = defaulte||defaultv||textid;
        field = "texte";
        break;
      }
      default:{
        _default = defaulte||defaultv||textid;
        field = "text_" + lang.toLowerCase();
      }
    }
    if(!this.labels) return _default;
    try{
      let _label;
      if(this.labels[textid.toUpperCase()]){
        _label = this.labels[textid.toUpperCase()][field];
      }
      if(!_label){
        _label = _default;
        //create label default
        if(!this.labels[textid.toUpperCase()]){
          let condition={
            labelid:this.config.get("app_code"),
            textid:textid.toUpperCase()
          }
          condition.texte = _default;
          condition.textv = _default;
          condition[field] = _default;
          this.labels[condition.textid] = condition;
          setTimeout(()=>{
            this.createLabel(condition);
          },0)
        }
      }
      return _label || "";
    }catch(e){
      console.log("error get label",e)
      return _default||textid||"";
    }
  }

  async asyncCountShared(access_token,condition,model_name){
    try{
        let countFloor = await this.asyncGetListShared(access_token,model_name,{condition:condition,count:1});
        countFloor.condition = condition;
        return countFloor;
    }catch(e){
      e.condition = condition;
      return e;
    }
  }
  getUserInfoByToken(token,callback){
    this.userInfo = null;

    let url = this.config.get("server_url_report") + "/api/user?access_token=" + token;
    this.get(url,null,(error,rs)=>{
      if(error) return callback(error);
      let userInfo = JSON.parse(rs);
      this.userInfo = userInfo;
      //get app info
      callback(null,userInfo);
    },{cache_local:false})
  }
  async asyncGetUserInfoByToken(token){
    this.userInfo = null;
    if(!token){
      try{
        token = await localStorage.getItem('token');
      }catch(e){
        if(e) console.error(e);
      }
    }
    if(!token) return null;
    let url = this.config.get("server_url_report") + "/api/user?access_token=" + token;
    let rs = await this.asyncGet(url,null,{cache:true,cache_local:false});
    let userInfo = JSON.parse(rs);
    this.userInfo = userInfo;
    return userInfo;
  }
  async asyncGetProfile(token,userName,options={cache:true,cache_local:false}){
    options.stringifyData = false;
    let url = this.config.get("server_url_report") + "/api/profile?access_token=" + token + "&email=" + userName;
    let rs =await this.asyncGet(url,null,options);
    return rs;
  }
  async asyncGetAppInfo(token,_id_app="",fields="",options={cache:true,cache_local:false}){
    if(!_id_app) _id_app = this.config.get("id_app");
    options.stringifyData = false;

    let url = this.config.get("server_url_report") + "/api/app/" + _id_app + "?access_token=" + token;
    if(fields) url = url + "&fields=" + fields;
    let rs = await this.asyncGet(url,null,options);
    //this.preload(_id_app,token);
    return rs;
  }

  /**
   * Tải một báo cáo theo khuân mẫu
   * @param {String} token Token để kết nối
   * @param {String} api_code api code của chứng từ cần tải
   * @param {Object} template Khuân mẫu dùng để format dữ liệu trước khi tải
   * @param {Object} searchCondition Khuân mẫu dùng để format dữ liệu trước khi tải
   * @param {String} download_type Kiểu tải. Có thể print hoặc file. 
   * @param {String} report_info_code Form phụ (code của form phụ, tuỳ chọn)
   * @returns 
   */
  async asyncDownloadReportWithTemplate(token,api_code,template,searchCondition,download_type="print",report_info_code = null,type_data=null,return_type="url"){
    let url = this.config.get("server_url_report") + "/api/" + this.config.get("id_app") + "/" + api_code + "/export?rpt=1&id_rpt=" + template._id + "&access_token=" + token;
    

    searchCondition.report_info_code = report_info_code;
    searchCondition.template = template;

    if(download_type=="print"){
      searchCondition.print = 1;
      let html =  await this.asyncPost(url,null,searchCondition,"post",'printreport',false);
      return {html}
    }else{
      delete searchCondition.print;
    }
    if(type_data){
      url = `${url}&type_data=${type_data}`
    }
    if(return_type){
      url = `${url}&return_type=${return_type}`
    }
    return this.asyncPost(url,null,searchCondition,"post","downloadreport",false,{stringifyData:false});
  }
  /**
   * Tải một chứng từ theo khuân mẫu
   * @param {String} token Token để kết nối
   * @param {String} api_code api code của chứng từ cần tải
   * @param {String} ids danh sách _id các chứng từ cần tải. ví dụ a1123,b1134
   * @param {Object} template Khuân mẫu dùng để format dữ liệu trước khi tải
   * @param {String} download_type Kiểu tải. Có thể print hoặc file. 
   * @param {String} listInfo_code Form phụ (code của form phụ, tuỳ chọn)
   * @returns 
   */
  async asyncDownloadVoucherWithTemplate(token,api_code,ids,template,download_type="print",listInfo_code = null){
    let url = this.config.get("server_url_report") + "/api/" + this.config.get("id_app")  + "/" + api_code + "/export/" + template._id + "?_id=" + ids + "&access_token=" + token;
    if(listInfo_code) url=`${url}&listinfo-code=${listInfo_code}`;
    if(download_type=="print"){
      url=`${url}&print=1`;
      let html = await this.asyncGet(url);
      return {html}
    }
    return new Promise((resovle,reject)=>{
      this.downloadFile(url, (template.file||{}).name || template.ten_mau_in,(e)=>{
        if(e) return reject(e);
        resovle();
      });
    })
  }
  async asyncGetReport(token,report,condition={},method="POST",report_info_code=null){
    try{
      const id_app = this.config.get("id_app");
      let url = this.config.get("server_url_report") + "/api/dispatch-report/" + id_app + "/" + report + "?access_token=" + token;
      if(!condition.rpt){
        url = `${url}&rpt=1`;
      }
      if(report_info_code) url = `${url}&report_info_code=${report_info_code}`;

      if(method=="GET"){
        for(let k in condition){
          let value = condition[k];
          if(value && k!=="drilldown"){
            if(isDate(value)) value = new Date(value).toISOString();
            if(typeof(value)=="object"){
              value = JSON.stringify(value);
            }

            url =`${url}&${k}=${encodeURIComponent(value)}`;
          }
        }
        let rs = await this.asyncGet(url,null,{stringifyData:false});
        return rs;
      }else{
        //console.log("[get report]",{report,condition});
        let rs = await this.asyncPost(url,null,condition,"POST","getreport",false,{stringifyData:false});
        return rs;
      }
    }catch(e){
      console.error(e);
      throw e;
    }
    
  }
  // ══════════════════════════════════════════════════════════════════════════════════════════
  // XÁC THỰC — JWT ngắn hạn + refresh token xoay vòng + PAT (token cá nhân kiểu GitHub)
  //
  // Server không còn lưu access token: nó là JWT tự hết hạn (mặc định 15 phút). Vì vậy client
  // BẮT BUỘC phải biết cách làm mới: gặp 401 với auth_code='token_expired' thì gọi /auth/refresh
  // rồi CHẠY LẠI đúng request vừa hỏng. Toàn bộ việc đó do interceptor bên dưới lo, mọi hàm API
  // sẵn có không phải sửa một dòng nào.
  //
  // Refresh token: web nhận qua cookie httpOnly (JS không đọc được -> XSS không cướp được phiên);
  // bản trong body chỉ dùng cho môi trường không có cookie (app nhúng, webview, React Native).
  // ══════════════════════════════════════════════════════════════════════════════════════════
  // ══════════════════════════════════════════════════════════════════════════════════════════
  // NĂNG LỰC MÁY CHỦ — máy chủ này có cài gói mở rộng nào (AI agent, flow, marketing...)?
  //
  // Core chạy được độc lập, các gói thương mại là TUỲ CHỌN. Không hỏi thì client cứ vẽ ra những nút
  // bấm vào là 404 — rõ nhất là nút "làm việc với AI" khi máy chủ không có gói agent.
  // Danh sách gói chỉ đổi khi máy chủ khởi động lại nên gọi ĐÚNG MỘT LẦN rồi dùng lại kết quả.
  // ══════════════════════════════════════════════════════════════════════════════════════════
  async asyncGetFeatures(token){
    if(this._featuresPromise) return this._featuresPromise;
    const t = token || this.getAccessToken() || this.config.get("public_token");
    this._featuresPromise = axios.get(`${this.config.get("server_url_report")}/api/features?access_token=${t}`,{withCredentials:true})
      .then(res=>{
        this._features = res.data || {};
        return this._features;
      })
      .catch(e=>{
        // Máy chủ ĐỜI CŨ chưa có endpoint này -> KHÔNG kết luận là thiếu tính năng, giữ nguyên hành vi
        // cũ (hiện đủ nút). Xoá promise để lần sau thử lại, phòng khi chỉ là lỗi mạng nhất thời.
        this._featuresPromise = null;
        this._features = { features:{}, unknown:true };
        console.warn("[features] không lấy được danh sách tính năng của máy chủ:", e && e.message);
        return this._features;
      });
    return this._featuresPromise;
  }

  /**
   * Máy chủ có tính năng này không? ai_agent | flow | marketing | usermodule
   * CHƯA BIẾT (chưa gọi xong, hoặc máy chủ đời cũ) -> trả true để không ẩn nhầm tính năng đang chạy tốt.
   */
  hasFeature(name){
    const f = this._features;
    if(!f || f.unknown || !f.features) return true;
    return f.features[name] !== false;
  }

  /**
   * Tên gói npm cần cài để có tính năng này ('usermodule' -> '@pvtruong/server-usermodule').
   * Để báo cho quản trị viên biết CHÍNH XÁC phải cài gói nào thay vì nói chung chung.
   * Máy chủ đời cũ chưa trả `packages` -> trả lại chính tên tính năng.
   */
  featurePackage(name){
    const f = this._features;
    return (f && f.packages && f.packages[name]) || name;
  }

  /**
   * ĐÃ HỎI XONG máy chủ chưa? (hỏi được hay hỏi hỏng đều tính là xong)
   * Chưa xong thì UI nên chờ, đừng vội báo "thiếu gói mở rộng" rồi lại đổi ý — nháy màn hình.
   * Hỏi hỏng (máy chủ đời cũ) cũng là XONG: lúc đó hasFeature trả true, UI cứ hiện như trước.
   */
  featuresLoaded(){
    return !!this._features;
  }

  _authUrl(p){ return this.config.get("server_url_report") + p; }

  _loadAuth(){
    try{
      return {
        access_token: localStorage.getItem("token") || "",
        refresh_token: localStorage.getItem("refresh_token") || "",
        expires_at: Number(localStorage.getItem("token_expires_at") || 0),
      };
    }catch(e){ return {access_token:"",refresh_token:"",expires_at:0}; }
  }

  /**
   * Lưu cặp token sau khi đăng nhập / làm mới.
   * Giữ nguyên key "token" trong localStorage để mã cũ (Provider, các màn hình) đọc được như trước.
   */
  setTokens(rs={}){
    const access = rs.access_token || rs.token;
    if(!access) return this._auth;
    this._auth = {
      access_token: access,
      // Không có refresh_token trong body nghĩa là đang dùng cookie httpOnly -> giữ giá trị cũ.
      refresh_token: rs.refresh_token || this._auth.refresh_token || "",
      expires_at: rs.expires_in ? (Date.now() + Number(rs.expires_in)*1000) : 0,
    };
    try{
      localStorage.setItem("token", this._auth.access_token);
      if(this._auth.refresh_token) localStorage.setItem("refresh_token", this._auth.refresh_token);
      localStorage.setItem("token_expires_at", String(this._auth.expires_at||0));
    }catch(e){}
    this._sessionDead = false;   // có token mới -> cho phép báo "phiên chết" lần sau
    this._emitAuthChange();
    return this._auth;
  }

  clearTokens(){
    this._auth = {access_token:"",refresh_token:"",expires_at:0};
    try{
      localStorage.setItem("token","");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token_expires_at");
    }catch(e){}
    this._emitAuthChange();
  }

  getAccessToken(){ return (this._auth && this._auth.access_token) || ""; }
  getRefreshToken(){ return (this._auth && this._auth.refresh_token) || ""; }

  /**
   * Đăng ký nhận thông báo khi access token đổi (sau mỗi lần làm mới).
   * Provider dùng cái này để cập nhật userInfo.token — nếu không, mọi request tiếp theo vẫn gắn
   * token cũ và đều phải đi đường vòng 401 -> refresh -> retry (tốn gấp đôi số request).
   * @returns {Function} hàm huỷ đăng ký
   */
  onAuthChange(cb){
    if(typeof cb!=="function") return ()=>{};
    this._authListeners.push(cb);
    return ()=>{ this._authListeners = this._authListeners.filter(f=>f!==cb); };
  }
  _emitAuthChange(){
    (this._authListeners||[]).forEach(cb=>{
      try{ cb({...this._auth}); }catch(e){ console.error("[auth] listener lỗi",e); }
    });
  }

  /**
   * Đăng ký nhận thông báo PHIÊN ĐÃ CHẾT — không thể cứu bằng refresh nữa:
   *   refresh_failed | session_revoked | token_used | invalid_token
   * Provider dùng cái này để dọn state và bật ngay màn đăng nhập, thay vì để người dùng bấm loanh
   * quanh giữa một giao diện mà request nào cũng 401.
   * @returns {Function} hàm huỷ đăng ký
   */
  onSessionExpired(cb){
    if(typeof cb!=="function") return ()=>{};
    this._sessionListeners.push(cb);
    return ()=>{ this._sessionListeners = this._sessionListeners.filter(f=>f!==cb); };
  }
  /** Phát sự kiện phiên chết ĐÚNG MỘT LẦN (nhiều request cùng 401 chỉ bật 1 màn đăng nhập). */
  _emitSessionExpired(reason){
    if(this._sessionDead) return;
    this._sessionDead = true;
    this.clearTokens();
    console.warn("[auth] phiên đăng nhập đã kết thúc:", reason);
    (this._sessionListeners||[]).forEach(cb=>{
      try{ cb({reason}); }catch(e){ console.error("[auth] session listener lỗi",e); }
    });
  }

  /** Request vừa hỏng có dùng ĐÚNG access token của phiên hiện tại không? */
  _requestUsedToken(cfg, token){
    if(!cfg || !token) return false;
    if(String(cfg.url||"").indexOf("access_token="+encodeURIComponent(token))>=0) return true;
    if(String(cfg.url||"").indexOf("access_token="+token)>=0) return true;
    const h = cfg.headers || {};
    if(h.Authorization === "Bearer "+token || h.authorization === "Bearer "+token) return true;
    if(h["access-token"] === token || h["X-Access-Token"] === token) return true;
    if(cfg.params && cfg.params.access_token === token) return true;
    return false;
  }

  /**
   * Đổi refresh token lấy cặp token mới. GỘP LỜI GỌI: nhiều request cùng hết hạn một lúc chỉ tạo
   * ĐÚNG MỘT lượt refresh — quan trọng vì server xoay vòng refresh token và phát hiện tái sử dụng,
   * gọi song song 2 lần sẽ bị coi là token bị đánh cắp và thu hồi cả phiên.
   */
  async asyncRefreshToken(){
    if(this._refreshing) return this._refreshing;
    const body = {};
    const rt = this.getRefreshToken();
    if(rt) body.refresh_token = rt;   // môi trường không cookie
    this._refreshing = axios.post(this._authUrl("/auth/refresh"), body, {withCredentials:true})
      .then(res=>{
        const rs = res.data || {};
        this.setTokens(rs);
        return rs;
      })
      .finally(()=>{ this._refreshing = null; });
    return this._refreshing;
  }

  // ══════════════════════════════════════════════════════════════════════════════════════════
  // KHOÁ TIN CẬY (trust key)
  //
  // Máy chủ dùng khoá này để xếp request vào nhóm "đáng tin" của bộ giới hạn tần suất
  // (auths/rateLimiterMiddleware.js). Request KHÔNG mang khoá, đến từ một origin lạ, sẽ bị tính giá
  // đắt hơn nhiều lần — hết quota là bị xếp hàng chờ rồi 429, người dùng thấy "app chạy rất chậm".
  //
  // Trước đây khoá chỉ được gắn ở 4 hàm nền (get/post/deleteRequest/uploadFile). Hơn 20 lời gọi
  // axios trực tiếp — toàn bộ nhóm /auth/*, /api/pats, /api/auth/sessions, /api/features, khôi phục
  // dữ liệu — đi thẳng ra ngoài KHÔNG có khoá. Và mỗi hàm API viết mới sau này lại phải nhớ tự thêm.
  // Nay chặn ở MỘT chỗ: interceptor của axios, nên không thể quên.
  // ══════════════════════════════════════════════════════════════════════════════════════════

  /** Khoá tin cậy đang cấu hình (không có thì trả rỗng — mọi thứ dưới đây thành no-op). */
  _trustKey(){
    try{ return this.config.get("trustkey") || ""; }catch(e){ return ""; }
  }

  /** Header khoá tin cậy để trộn vào lời gọi tự dựng header. Không cấu hình -> object rỗng. */
  _trustHeaders(){
    const key = this._trustKey();
    return key ? {"x-trust-key": key} : {};
  }

  /**
   * Các origin THUỘC VỀ máy chủ của mình. Chỉ gắn khoá cho những origin này.
   * Khoá tin cậy là BÍ MẬT: axios ở đây là instance dùng chung cả ứng dụng, nếu gắn vô tội vạ thì
   * một lời gọi tới dịch vụ bên thứ ba (bản đồ, thanh toán, CDN...) sẽ mang khoá của mình đi cho họ.
   */
  _ownOrigins(){
    if(this.__ownOrigins) return this.__ownOrigins;
    const out = [];
    ["server_url","server_url_report","server_url_socket","api_url"].forEach(k=>{
      let v;
      try{ v = this.config.get(k); }catch(e){ v = null; }
      if(!v || typeof v !== "string") return;
      try{ out.push(new URL(v).origin); }catch(e){ /* cấu hình không phải URL tuyệt đối -> bỏ qua */ }
    });
    this.__ownOrigins = [...new Set(out)];
    return this.__ownOrigins;
  }

  /** URL này có trỏ về máy chủ của mình không? (đã tính cả baseURL và URL tương đối) */
  _isOwnServerUrl(url, baseURL){
    const origins = this._ownOrigins();
    if(!origins.length) return false;
    let full = String(url || "");
    if(baseURL && !/^[a-z][a-z0-9+.-]*:\/\//i.test(full)){
      full = String(baseURL).replace(/\/+$/,"") + "/" + full.replace(/^\/+/,"");
    }
    let base;
    try{ base = (typeof window!=="undefined" && window.location) ? window.location.href : undefined; }catch(e){ base = undefined; }
    try{
      return origins.indexOf(new URL(full, base).origin) >= 0;
    }catch(e){
      return false;   // URL tương đối mà không biết origin trang -> không đoán, không gắn
    }
  }

  /**
   * Gắn khoá tin cậy vào MỌI request axios đi tới máy chủ của mình.
   * Nơi gọi đã tự đặt header thì giữ nguyên (không ghi đè).
   */
  _installTrustKeyInterceptor(){
    if(this._trustInterceptorInstalled) return;
    // axios ở đây là instance TOÀN CỤC dùng chung. Ứng dụng có thể tạo nhiều đối tượng APIs (nhiều
    // máy chủ, nhiều tab, hot-reload) — nếu mỗi lần tạo lại cắm thêm một interceptor thì chúng chồng
    // lên nhau vô hạn. Ghi dấu theo (origin + khoá) ở cấp module để cùng cấu hình chỉ cắm một lần.
    const sig = this._ownOrigins().join(",") + "|" + this._trustKey();
    this._trustInterceptorInstalled = true;
    if(_trustInterceptorSigs.has(sig)) return;
    _trustInterceptorSigs.add(sig);
    axios.interceptors.request.use((cfg)=>{
      try{
        const key = this._trustKey();
        if(!key || !cfg) return cfg;
        if(!this._isOwnServerUrl(cfg.url, cfg.baseURL)) return cfg;
        if(!cfg.headers) cfg.headers = {};
        const h = cfg.headers;
        // axios 1.x dùng lớp AxiosHeaders (có has/set); axios 0.x là object thường.
        if(typeof h.has === "function" && typeof h.set === "function"){
          if(!h.has("x-trust-key")) h.set("x-trust-key", key);
        }else{
          const hasKey = Object.keys(h).some(n=>String(n).toLowerCase()==="x-trust-key");
          if(!hasKey) h["x-trust-key"] = key;
        }
      }catch(e){
        // Không bao giờ để việc gắn khoá làm hỏng request — thiếu khoá chỉ là chạy chậm hơn.
        console.warn("[trustkey] không gắn được khoá tin cậy:", e && e.message);
      }
      return cfg;
    });
  }

  /**
   * Gắn khoá tin cậy vào QUERY của một URL — dùng cho những chỗ KHÔNG đi qua axios nên không đặt
   * được header: fetch tải file, <img src>, <a href>, window.open, thẻ iframe...
   * Idempotent: gọi nhiều lần không nhân bản tham số.
   */
  withTrustKey(url){
    const key = this._trustKey();
    if(!key || !url) return url;
    if(/[?&]trustkey=/.test(url)) return url;
    if(!this._isOwnServerUrl(url)) return url;
    return url + (url.indexOf("?") < 0 ? "?" : "&") + "trustkey=" + encodeURIComponent(key);
  }

  /**
   * Interceptor: 401 + token hết hạn -> tự làm mới rồi CHẠY LẠI request cũ (đúng 1 lần).
   * Chỉ làm mới khi server báo đúng 'token_expired'. Các lỗi khác (thu hồi phiên, token dùng 1 lần
   * đã dùng, sai token) KHÔNG thử lại — thử lại chỉ tổ lộ thêm và làm chậm phản hồi.
   */
  _installAuthInterceptor(){
    if(this._authInterceptorInstalled) return;
    this._authInterceptorInstalled = true;
    axios.interceptors.response.use(r=>r, async (error)=>{
      const cfg = error && error.config;
      const status = error && error.response && error.response.status;
      if(!cfg || status!==401 || cfg.__fbzRetried) return Promise.reject(error);
      if(String(cfg.url||"").indexOf("/auth/refresh")>=0) return Promise.reject(error);   // tránh lặp vô hạn

      const data = (error.response||{}).data || {};
      const authCode = data.auth_code || "";
      const msg = String(data.error || data.message || "");
      const expired = authCode==="token_expired" || (!authCode && /hết hạn|expired/i.test(msg));

      if(!expired){
        // Không cứu được bằng refresh. Nếu request này dùng ĐÚNG token của phiên hiện tại thì phiên
        // đã chết thật (bị thu hồi từ thiết bị khác, đổi mật khẩu, token dùng-1-lần đã dùng...).
        // Chỉ khi đó mới bắt đăng nhập lại — request bằng public_token hay PAT hỏng thì không được
        // đá người dùng ra khỏi phiên đang tốt.
        const cur = this.getAccessToken();
        const isPublic = cur && this.config.get("public_token")===cur;
        const dead = ["session_revoked","token_used","invalid_token","account_disabled"].indexOf(authCode)>=0;
        if(dead && cur && !isPublic && this._requestUsedToken(cfg, cur)){
          this._emitSessionExpired(authCode);
        }
        return Promise.reject(error);
      }

      try{
        const rs = await this.asyncRefreshToken();
        const fresh = rs.access_token || rs.token;
        if(!fresh) return Promise.reject(error);
        cfg.__fbzRetried = true;
        cfg.url = this._replaceTokenInUrl(cfg.url, fresh);
        if(cfg.params && cfg.params.access_token) cfg.params.access_token = fresh;
        if(cfg.headers){
          if(cfg.headers.Authorization) cfg.headers.Authorization = "Bearer " + fresh;
          if(cfg.headers["access-token"]) cfg.headers["access-token"] = fresh;
        }
        if(cfg.data && typeof cfg.data==="string" && cfg.data.indexOf("access_token")>=0){
          try{
            const parsed = JSON.parse(cfg.data);
            if(parsed && parsed.access_token){ parsed.access_token = fresh; cfg.data = JSON.stringify(parsed); }
          }catch(e){}
        }
        return axios(cfg);
      }catch(e){
        // Refresh cũng hỏng -> phiên thực sự kết thúc: xoá token VÀ báo cho Provider bật màn đăng nhập.
        this._emitSessionExpired("refresh_failed");
        return Promise.reject(error);
      }
    });
  }

  /** Thay giá trị access_token trong query string của URL (token được gắn vào URL ở khắp nơi). */
  _replaceTokenInUrl(url, token){
    if(!url) return url;
    if(url.indexOf("access_token=")<0) return url;
    return url.replace(/access_token=[^&#]*/g, "access_token=" + encodeURIComponent(token));
  }

  /** Thông tin phiên hiện tại theo góc nhìn server (loại token, scope, hạn dùng). */
  async asyncAuthMe(token){
    const t = token || this.getAccessToken();
    const res = await axios.get(this._authUrl("/auth/me"), {withCredentials:true, headers:{Authorization:"Bearer "+t}});
    return res.data;
  }

  /** Thu hồi TẤT CẢ phiên của tài khoản (đổi mật khẩu, nghi lộ token...). */
  async asyncLogoutAll(token){
    const t = token || this.getAccessToken();
    const res = await axios.post(this._authUrl("/auth/logout-all"), {}, {withCredentials:true, headers:{Authorization:"Bearer "+t}});
    this.clearTokens();
    return res.data;
  }

  // ── TOKEN CÁ NHÂN (PAT) — dùng cho ứng dụng/script bên ngoài kết nối API ────────────────────
  _patUrl(sub=""){ return `${this.config.get("server_url_report")}/api/pats${sub}`; }

  async asyncGetPats(token){
    const t = token || this.getAccessToken();
    const res = await axios.get(`${this._patUrl()}?access_token=${t}`, {withCredentials:true});
    return res.data || [];
  }

  /**
   * Tạo token cá nhân. GIÁ TRỊ TOKEN CHỈ TRẢ VỀ ĐÚNG LẦN NÀY — server chỉ lưu hash, không lấy lại được.
   * @param {object} data {name, scopes:['read'|'write'], only_id_app, id_apps, expires_in_days, no_expire, note}
   */
  async asyncCreatePat(token, data={}){
    const t = token || this.getAccessToken();
    const res = await axios.post(`${this._patUrl()}?access_token=${t}`, data, {withCredentials:true});
    return res.data;
  }

  async asyncUpdatePat(token, id, data={}){
    const t = token || this.getAccessToken();
    const res = await axios.patch(`${this._patUrl("/"+id)}?access_token=${t}`, data, {withCredentials:true});
    return res.data;
  }

  /** Thu hồi (giữ lại bản ghi để còn thấy lịch sử). */
  async asyncRevokePat(token, id){
    const t = token || this.getAccessToken();
    const res = await axios.delete(`${this._patUrl("/"+id)}?access_token=${t}`, {withCredentials:true});
    return res.data;
  }

  /** Xoá hẳn khỏi danh sách. */
  async asyncDeletePat(token, id){
    const t = token || this.getAccessToken();
    const res = await axios.delete(`${this._patUrl("/"+id)}?access_token=${t}&purge=true`, {withCredentials:true});
    return res.data;
  }

  /** Thu hồi token cũ + phát token mới cùng cấu hình (trả về giá trị mới, cũng chỉ 1 lần). */
  async asyncRotatePat(token, id){
    const t = token || this.getAccessToken();
    const res = await axios.post(`${this._patUrl("/"+id+"/rotate")}?access_token=${t}`, {}, {withCredentials:true});
    return res.data;
  }

  // ── PHIÊN ĐĂNG NHẬP (thiết bị) ─────────────────────────────────────────────────────────────
  async asyncGetSessions(token){
    const t = token || this.getAccessToken();
    const res = await axios.get(`${this.config.get("server_url_report")}/api/auth/sessions?access_token=${t}`, {withCredentials:true});
    return res.data || [];
  }
  async asyncRevokeSession(token, sid){
    const t = token || this.getAccessToken();
    const res = await axios.delete(`${this.config.get("server_url_report")}/api/auth/sessions/${sid}?access_token=${t}`, {withCredentials:true});
    return res.data;
  }
  /** Đăng xuất mọi thiết bị KHÁC, giữ nguyên thiết bị đang dùng. */
  async asyncRevokeOtherSessions(token){
    const t = token || this.getAccessToken();
    const res = await axios.delete(`${this.config.get("server_url_report")}/api/auth/sessions?access_token=${t}`, {withCredentials:true});
    return res.data;
  }

  loginAPI(username,password,callback,options={}){
    if(!options.id_app) options.id_app = this.config.get("id_app");
    if(!options.group_id) options.group_id = this.config.get("group_id");//group_id là _id của usergroup (backend sẽ tự động add user vừa đăng nhập này vào usergroup này nếu user này lần đầu đăng nhập hệ thống và chưa nằm trong nhóm nào)

    let url = this.config.get("server_url_report") + "/auth/local";

    if(options.id_app){
      url = `${url}?id_app=${options.id_app}`;
      username = `${username}@app=${options.id_app}`
      if(options.group_id){
        url = `${url}&group_id=${options.group_id}`;
      }
    }
    if(options.once){
      url = `${url}&once=1`
    }

    let Authorization = "Basic " + (Buffer.from(username + ":" + password).toString("base64"));
    this.get(url,[{name:'Authorization',value:Authorization}],(error,token)=>{
      if(error){
        console.log(error);
        try{
          error = JSON.parse(error);
          return callback(error);
        }catch(e){
          return callback(error);
        }
      }
      // Server nay trả {access_token, token, expires_in, refresh_token, sid}. Giữ tương thích với
      // bản cũ (chỉ có `token`) bằng cách ưu tiên access_token rồi mới tới token.
      let loginRs = token;
      try{
        loginRs = (typeof token === "string") ? JSON.parse(token) : token;
      }catch(e){
        loginRs = {token};
      }
      token = loginRs.access_token || loginRs.token;
      // Lưu access + refresh: từ đây interceptor tự làm mới khi access token hết hạn (15 phút).
      this.setTokens(loginRs);

      if(!options.once){
        this.getUserInfoByToken(token,(error,userInfo)=>{
          if(error){
            return callback(error);
          }
          userInfo.token = token;
          userInfo.expires_in = loginRs.expires_in;
          userInfo.sid = loginRs.sid;
          callback(null,userInfo);
        })
      }else{
        callback(null,{token:token,expires_in:loginRs.expires_in,sid:loginRs.sid});
      }
    })
  }
  async asyncLoginAPI(username,password,options){
    return new Promise((resolve,reject)=>{
      this.loginAPI(username,password,(e,rs)=>{
        if(e) return reject(e);
        resolve(rs);
      },options)
    })
  }
  async asyncLoginSms(phone,id_app){
    let url = this.config.get("server_url_report") + `/send-otp/${phone}`
    let self = this;
    return new Promise((resolve,reject)=>{
      grecaptcha.ready(function() {
        grecaptcha.execute(self.config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {action: "SENDOTP"})
        .then(function(token) {
          url = `${url}?g-recaptcha-response=${token}`;
          if(!id_app) id_app = self.config.get("id_app");

          if(id_app){
            url = `${url}&id_app=${id_app}`;
          }
          self.asyncGet(url).then(rs=>{
            resolve(rs);
          }).catch(e=>{
            reject(e);
          })
        },function(e){
          reject({message:e||"Lỗi khi tải google recaptcha",code:400})
        });
      });
    })
  }
  async asyncLoginSmsVerify(id,otp,options={}){
    let url = this.config.get("server_url_report") + `/verify-otp/${id}/${otp}?t=1`
    
    if(!options.id_app) options.id_app = this.config.get("id_app");
    if(!options.group_id) options.group_id = this.config.get("group_id");
    
    if(options.id_app && options.group_id){
      url = `${url}&id_app=${options.id_app}&group_id=${options.group_id}`;
    }
    if(options.once){
      url = `${url}&once=1`
    }
    let rs = await this.asyncGet(url);
    try{
      rs = (typeof rs === "string") ? JSON.parse(rs) : rs;
    }catch(e){
      rs = {token:rs};
    }
    let token = rs.access_token || rs.token;
    this.setTokens(rs);   // lưu luôn refresh token của phiên vừa tạo
    let userInfo={};
    if(!options.once){
      userInfo = await this.asyncGetUserInfoByToken(token);
    }
    userInfo.token = token;
    return userInfo;
  }
  async asyncSign(username,password,data){
    let url = this.config.get("server_url_report") + "/auth/sign";
    let Authorization = "Basic " + (Buffer.from(username + ":" + password).toString("base64"));
    return await this.asyncPost(url,[{name:'Authorization',value:Authorization}],data,"POST","POST",false);
  }

  /**
   * Gỡ đăng ký thông báo đẩy khỏi máy chủ.
   * `ep` là chuỗi JSON của PushSubscription; không truyền thì rơi về biến toàn cục `endpoint`
   * (ứng dụng di động vẫn dùng đường này). Chuỗi PHẢI được encode: JSON có ký tự { } " / +
   * nếu ghép thẳng vào query thì máy chủ nhận về chuỗi khác -> xoá trượt, người dùng "đã tắt"
   * mà vẫn nhận thông báo.
   */
  async removeEndpoint(userInfo,callback,ep){
    // eslint-disable-next-line no-undef
    const endpointStr = ep || (typeof window!=="undefined" ? window.endpoint : (typeof endpoint!=="undefined" ? endpoint : null));
    if(endpointStr && endpointStr!=="null" && endpointStr!=="undefined"){
      let url = this.config.get("server_url_report") + "/api/remove-endpoint?access_token=" + userInfo.token + "&ep=" + encodeURIComponent(endpointStr);
      this.get(url,null,(error)=>{
        callback(error);
      })
    }else{
      callback()
    }
  }
  logoutAPI(userInfo,callback){
    this.removeEndpoint(userInfo,(error)=>{
      if(error) return callback(error);
      let url =  this.config.get("server_url_report") + "/api/user/logout?access_token=" + userInfo.token;
      if(endpoint) url = url + "&ep=" + endpoint;
      this.get(url,null,(error,rs)=>{
        if(error) return callback(error);
        // THU HỒI PHIÊN Ở SERVER: xoá token phía client là chưa đủ — refresh token vẫn sống tới 30
        // ngày và ai có nó vẫn cấp lại được access token. /auth/logout đánh dấu phiên revoked, đồng
        // thời đưa sid vào denylist nên access token còn hạn cũng chết ngay. Lỗi ở bước này không
        // được chặn việc đăng xuất phía client.
        const body = {};
        const rt = this.getRefreshToken();
        if(rt) body.refresh_token = rt;
        axios.post(this._authUrl("/auth/logout"), body, {withCredentials:true})
          .catch(e=>console.warn("[auth] /auth/logout lỗi (bỏ qua):", e && e.message));
        this.clearTokens();
        //clear cache
        for(let i=0;i<localStorage.length;i++){
          let key = localStorage.key(i);
          if(key.indexOf("labelinfo")<0 && key.indexOf("my_device_id")<0 && key.indexOf("listinfo")<0 && key.indexOf("reportinfo")<0 && key.indexOf("lang")<0){
            localStorage.removeItem(key);
          }
        }
        callback(null,rs)
      })
    })
  }
  async asyncLogoutAPI(userInfo){
    return new Promise((resolve,reject)=>{
      this.logoutAPI(userInfo,(e,rs)=>{
        if(e) return reject(e);
        resolve(rs);
      })
    })
  }
  signup(data,callback,_id_app,group_id){
    let _this = this;
    const config = this.config;

    if(!_id_app) _id_app = config.get("id_app");
    if(!group_id) group_id = this.config.get("group_id");//group_id là _id của usergroup (backend sẽ tự động add user vừa đăng ký vào usergroup này)

    if(config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha!=='undefined'){
      grecaptcha.ready(function() {
        grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {action: 'signup'})
        .then(function(token) {
          let url = config.get("server_url_report") + "/signup";

          data.group_id = data.group_id || group_id;
          data.id_app = data.id_app ||  _id_app;

          data["g-recaptcha-response"]  = token;
          _this.post(url,null,data,(e,rs)=>{
            if(e) return callback(e);
            callback(null,rs)
          },"POST",{stringifyData:false,withCredentials:true})
        },function(error){
          //console.error("google recaptcha",error,GOOGLE_RECAPTCHA_SITE_KEY);
          callback({message:error||"Lỗi khi tải google recaptcha",code:400})
        });
      });
    }else{
      let url = config.get("server_url_report") + "/signup";
      data.group_id = data.group_id ||  group_id;
      data.id_app = data.id_app ||  _id_app;
      _this.post(url,null,data,(e,rs)=>{
        if(e) return callback(e);
        callback(null,rs)
      },"POST",{stringifyData:false,withCredentials:true})
    }
  }
  async asyncSignup(data,options={}){
    let _this = this;
    return new Promise((resolve,reject)=>{
      _this.signup(data,(e,rs)=>{
        if(e){
          return reject(e);
        }
        resolve(rs);
      },options.id_app,options.group_id)
    })
  }
  async asyncResetPassword(email){
    const config = this.config;
    const asyncGet = this.asyncGet;
    if(config.get("GOOGLE_RECAPTCHA_SITE_KEY") && typeof grecaptcha!=='undefined'){
      return await new Promise((resolve,reject)=>{
        grecaptcha.ready(function() {
          grecaptcha.execute(config.get("GOOGLE_RECAPTCHA_SITE_KEY"), {action: 'resetPassword'})
          .then(async (_token_captcha)=> {
            let url = `${config.get("server_url_report")}/resetpassword?email=${email}&g-recaptcha-response=${_token_captcha}`;
            let rs =  await asyncGet(url);
            resolve(rs);
          },function(error){
            //console.error("google recaptcha",error,GOOGLE_RECAPTCHA_SITE_KEY);
            reject({message:error||"Lỗi khi tải google recaptcha",code:400});
          });
        });
      })
    }else{
      let url = `${config.get("server_url_report")}/resetpassword?email=${email}`;
      let rs =  await asyncGet(url);
      return rs;
    }
  }
  async asyncChangePasswordByAdmin(token,passwords){
    let url = `${this.config.get("server_url_report")}/api/changepasswordByAdmin?access_token=${token}`;
    //console.log("asyncChangePasswordByAdmin",passwords,url);
    let rs =  await this.asyncPost(url,null,passwords,"POST","changePasswordByAdmin");
    return rs;
  }
  async asyncChangePassword(token,passwords){
    let url = `${this.config.get("server_url_report")}/api/changepassword?access_token=${token}`;
    let rs =  await this.asyncPost(url,null,passwords,"POST","changePassword");
    return rs;
  }

  // ── ĐỔI TÊN ĐĂNG NHẬP ──────────────────────────────────────────────────────
  // Một tài khoản có HAI thứ khác nhau, đừng nhầm:
  //   userInfo.user_key : KHOÁ ĐỊNH DANH bất biến (bằng userInfo.email). Toàn bộ phân
  //                       quyền, ACL và dữ liệu nghiệp vụ tham chiếu giá trị này. Đây là
  //                       thứ cần lưu nếu bạn đối chiếu người dùng ở hệ thống bên ngoài.
  //   userInfo.login    : TÊN ĐĂNG NHẬP hiện tại, ĐỔI ĐƯỢC. Đây là thứ phải HIỂN THỊ và
  //                       là thứ người dùng gõ khi đăng nhập.
  // Đổi tên KHÔNG làm mất phiên: JWT mang user_key nên token đang dùng vẫn hợp lệ.

  /**
   * Tên đăng nhập mới còn trống không?
   * @param {String} token access token
   * @param {String} login tên đăng nhập muốn kiểm tra
   * @returns {Promise<{available:Boolean, login?:String, reason?:String}>}
   */
  async asyncCheckLoginAvailable(token,login){
    let url = `${this.config.get("server_url_report")}/api/change-login/available?access_token=${token}&login=${encodeURIComponent(login||"")}`;
    let rs = await this.asyncGet(url,null,{cache:false,cache_local:false});
    return typeof rs === "string" ? JSON.parse(rs) : rs;
  }

  /**
   * Người dùng TỰ đổi tên đăng nhập của mình.
   * Phải kèm MỘT trong hai cách xác thực: OTP hoặc mật khẩu hiện tại.
   * @param {String} token access token
   * @param {Object} data {new_login, "otp-id"?, "otp-code"?, password?, reason?}
   * @returns {Promise<{ok:Boolean, login:String, old_login:String, participants_updated:Number}>}
   */
  async asyncChangeLogin(token,data){
    let url = `${this.config.get("server_url_report")}/api/change-login?access_token=${token}`;
    let rs = await this.asyncPost(url,null,data,"POST","changeLogin");
    return typeof rs === "string" ? JSON.parse(rs) : rs;
  }

  /**
   * Admin HỆ THỐNG đổi tên đăng nhập hộ một tài khoản bất kỳ.
   * @param {String} token access token
   * @param {Object} data {user, new_login, reason?} — `user` nhận tên đăng nhập hiện tại HOẶC khoá định danh
   */
  async asyncChangeLoginByAdmin(token,data){
    let url = `${this.config.get("server_url_report")}/api/change-login-by-admin?access_token=${token}`;
    let rs = await this.asyncPost(url,null,data,"POST","changeLoginByAdmin");
    return typeof rs === "string" ? JSON.parse(rs) : rs;
  }

  /**
   * Admin CÔNG TY đổi tên đăng nhập cho một thành viên.
   * Máy chủ chỉ chấp nhận khi thành viên đó chỉ tham gia duy nhất công ty này —
   * tên đăng nhập dùng chung cho toàn hệ thống.
   * @param {String} token access token
   * @param {Object} data {user, new_login, reason?}
   * @param {String} [_id_app] mặc định lấy từ config
   */
  async asyncChangeLoginOfMember(token,data,_id_app){
    if(!_id_app) _id_app = this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/change-login-of-member?access_token=${token}`;
    let rs = await this.asyncPost(url,null,data,"POST","changeLoginOfMember");
    return typeof rs === "string" ? JSON.parse(rs) : rs;
  }

  async asyncGetCustomerByEmail(access_token,email,fields,_id_app){
    if(!_id_app) _id_app = this.config.get("id_app");
    let condition ={of_user:email};
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/customer?q=${JSON.stringify(condition)}&access_token=${access_token}`;
    if(fields){
      url = url + "&fields=" + fields;
    }
    let rs = await this.asyncGet(url);
    rs =  JSON.parse(rs);
    if(rs.length>0){
      return rs[0];
    }else{
      throw new Error(`Not found customer for user ${email}`);
    }
  }
  async asyncGetPaymentMethods(access_token,_id_app){
    if(!_id_app) _id_app = this.config.get("id_app");
    let condition={status:true,hinh_thuc:{$in:[1,2,undefined]}};
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/ptthanhtoan?access_token=${access_token}&q=${JSON.stringify(condition)}`;
    let rs = await this.asyncGet(url);
    return JSON.parse(rs).map(r=>{r.key=r._id;return r});
  }
  async getWalletByAddress(address,access_token){
    let condition ={address:address};
    let url = `${this.config.get("server_url_report")}/api/asskey?q=${JSON.stringify(condition)}&access_token=${access_token}`;
    let rs = JSON.parse(await this.asyncGet(url));
    if(rs.length===1) return rs[0]
    return null
  }
  /**
   * fetch() không đi qua interceptor axios — gặp 401 phải tự xử lý phiên như interceptor (_installAuthInterceptor):
   * token hết hạn -> làm mới (gộp lời gọi) rồi gọi lại MỘT lần bằng token mới; phiên chết / làm mới hỏng -> báo
   * phiên kết thúc để Provider mở form đăng nhập. Trả { url, response, ketThuc } — url đổi theo token mới vì nơi gọi
   * có thể dùng lại url (vd nhánh app di động của downloadFile). Component dùng
   * flexbiz-core/components/auth/fetchXacThuc.js (cùng quy tắc).
   */
  async _fetchLaiSau401(url, response){
    let data = {};
    try{ data = await response.clone().json(); }catch(e){ data = {}; }
    const authCode = (data && data.auth_code) || "";
    const msg = String((data && (data.error || data.message)) || "");
    const expired = authCode==="token_expired" || (!authCode && /hết hạn|expired/i.test(msg));
    const m = /[?&]access_token=([^&#]*)/.exec(String(url||""));
    let tokenCu = "";
    if(m){ try{ tokenCu = decodeURIComponent(m[1]); }catch(e){ tokenCu = m[1]; } }
    if(!tokenCu) return {url, response, ketThuc:false};          // request không mang token -> không phải chuyện phiên
    const cur = this.getAccessToken();
    const isPublic = !!(cur && this.config.get("public_token")===cur) || this.config.get("public_token")===tokenCu;
    if(!expired){
      const dead = ["session_revoked","token_used","invalid_token","account_disabled"].indexOf(authCode)>=0;
      if(dead && cur && !isPublic && tokenCu===cur){ this._emitSessionExpired(authCode); return {url, response, ketThuc:true}; }
      return {url, response, ketThuc:false};
    }
    if(isPublic) return {url, response, ketThuc:false};
    try{
      // Phiên đã được làm mới ở chỗ khác (url còn mang token cũ) -> dùng luôn token hiện tại, không refresh nữa.
      let fresh = (cur && cur!==tokenCu) ? cur : "";
      if(!fresh){ const rs = await this.asyncRefreshToken(); fresh = (rs && (rs.access_token || rs.token)) || ""; }
      if(!fresh) throw new Error("không nhận được token mới");
      const url2 = this._replaceTokenInUrl(url, fresh);
      const response2 = await fetch(url2);
      if(response2.status===401){ this._emitSessionExpired("refresh_failed"); return {url:url2, response:response2, ketThuc:true}; }
      return {url:url2, response:response2, ketThuc:false};
    }catch(e){
      this._emitSessionExpired("refresh_failed");
      return {url, response, ketThuc:true};
    }
  }

  async downloadFile(url, name, callback) {
    // fetch chứ không phải axios -> interceptor không với tới, phải tự gắn khoá vào query.
    url = this.withTrustKey(url);

    try {
      let response = await fetch(url);

      // Token hết hạn giữa chừng: tự làm mới rồi tải lại; không cứu được thì form đăng nhập đã mở — KHÔNG alert câu
      // "Token đã hết hạn, hãy làm mới phiên" (người dùng từng phải tự đăng xuất / đăng nhập lại mới tải được).
      if (response.status === 401) {
        const kq = await this._fetchLaiSau401(url, response);
        url = kq.url;
        response = kq.response;
        if (kq.ketThuc) {
          const loi = { error: "Phiên đăng nhập đã hết — vui lòng đăng nhập lại.", auth_code: "session_expired" };
          if (callback) callback(loi);
          return;
        }
      }

      if (!response.ok) {
        let errorText = await response.text();
        try {
          errorText = JSON.parse(errorText);
        } catch (e) {
          console.error(e);
        }
        
        if (callback) callback(errorText || { error: "Lỗi kết nối server" });
        else alert(typeof errorText === 'object' ? JSON.stringify(errorText) : errorText);
        return;
      }

      const contentType = response.headers.get("Content-Type") || "";
      const contentDisposition = response.headers.get("Content-Disposition") || "";

      const isJson = contentType.includes("application/json");
      const isText = contentType.includes("text/");
      const isAttachment = contentDisposition.toLowerCase().includes("attachment") || url.includes("download=1")|| url.includes("action=donwload");


      // TRƯỜNG HỢP 1: Kết quả trả về là nội dung TEXT/JSON
      if ((isJson || isText) && !isAttachment) {
        let data = isJson ? await response.json() : await response.text();
        if (callback) callback(null, data); 
        return data;
      }

      // TRƯỜNG HỢP 2: FILE DOWNLOAD
      
      // 2A. Xử lý riêng cho Mobile App (ReactNativeWebView)
      if (window.ReactNativeWebView) {
        if (window.download) {
          if (callback) callback(null, true);
          window.download(url, name);
          return true;
        } else if (navigator.share) {
          try {
            let public_token = this.config.get("public_token");
            if (!public_token) {
              if (callback) callback({ error: "Không thể chia sẻ file này" });
              else alert("Không thể chia sẻ file này");
              return;
            }

            let shareUrl = url;
            try {
              const urlObj = new URL(url, window.location.origin);
              urlObj.searchParams.set('access_token', public_token);
              shareUrl = urlObj.toString();
            } catch (error) {
              if (callback) callback(error);
              else alert("Lỗi khi parse URL để share: " + error.message);
              return;
            }

            await navigator.share({ url: shareUrl });
            if (callback) callback(null, true);
            return true;
          } catch (error) {
            console.log("Hủy share hoặc lỗi:", error);
            if (callback) callback({ error: error.message || error.error || error });
            return;
          }
        } else {
          if (callback) callback({ error: "Trình duyệt ứng dụng không hỗ trợ tải file" });
          else alert("Trình duyệt ứng dụng không hỗ trợ tải file");
          return;
        }
      }

      // 2B. Xử lý cho Trình duyệt Web thông thường
      const arrayBuffer = await response.arrayBuffer();
      const blob = new Blob([arrayBuffer]);
      
      let finalName = name || "";

      // === CẢI TIẾN: THUẬT TOÁN TÁCH FILENAME TỪ CONTENT-DISPOSITION ===
      if (contentDisposition) {
        // 1. Ưu tiên bóc tách theo chuẩn mã hóa UTF-8 (filename*=UTF-8''...)
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;\n]*)/i);
        if (utf8Match && utf8Match[1]) {
          try {
            finalName = decodeURIComponent(utf8Match[1]);
          } catch (e) {
            finalName = utf8Match[1];
          }
        } else {
          // 2. Fallback bóc tách theo chuỗi filename="..." thông thường
          const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i);
          if (match && match[1]) {
            finalName = match[1].replace(/['"]/g, '').trim();
          }
        }
      }

      // 3. Nếu vẫn không bóc được tên từ Content-Disposition thì dùng tên truyền vào hoặc mặc định
      if (!finalName) {
        finalName = name || "downloaded_file";
      }

      // 4. Bổ sung đuôi mở rộng nếu chưa có
      if (finalName.indexOf(".") < 0 && typeof getExtensionFromMime === "function") {
        const ext = getExtensionFromMime(contentType);
        if (ext) finalName += "." + ext;
      }

      // Thực hiện tải xuống
      if (typeof saveAs === "function") {
        saveAs(blob, finalName);
      } else {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = finalName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
      }

      if (callback) callback(null, true); 
      return true;

    } catch (error) {
      if (callback) callback(error);
      else alert("Lỗi hệ thống: " + error.message);
    }
  }


  uploadSingleFile(token,fileRaw,data={}){
    return new Promise((resolve, reject) => {
      let url = `${this.config.get("server_url")}/api/${this.config.get("id_app")}/file?json=1&access_token=${token}`;
      data.name = data.name||"file";
      this.uploadFile(url, fileRaw, (error, rs) => { if (error) reject(error); else resolve(JSON.parse(rs)); }, data);
    })
  }
  uploadFile(url,fileRaw,callback=()=>{},data={}) {
    data.return = "JSON";
    data[data.name || "fileupload"] = fileRaw;
    let formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }

    let _headers ={"Content-Type": "multipart/form-data"};
    Object.assign(_headers, this._trustHeaders());

    axios({
      method: "post",
      url: url,
      data: formData,
      withCredentials: true,
      headers: _headers,
    }).then(response=>{
      let text = (typeof(response.data)=="object"?JSON.stringify(response.data):response.data)
      callback(null,text,response);
    }).catch(e=>{
      let error = (e.response?e.response.data:e) || e
      //console.error("Error get data:",error);
      callback(error);
    })
  }
  async asyncGetModules(userInfo,group,id_app,log=null,cache=false){
    if(!log) log = ()=>{};
    //console.log("get module 1");
    if(!id_app) id_app = this.config.get("id_app");
    let system_code = this.config.get("system_code");
    let token,_menu;
    if(isObject(userInfo)){
      token = userInfo.token
    }else{
      token = userInfo;
    }
    if(!token || !id_app) return {modules:[],menu:[]};
    let modules = cloneDeep(this.config.get("modules")||[]);
    modules.forEach(m=>{
      m.code = (m.code || m.title || "").toLowerCase()
      m.items = m.items.filter(i=>i.code)
    })
    //get menu on server
    log("Get module info:" + system_code)
    let condition = {app:system_code,id_app};
    //console.log("get module 2");
    let extra_modules = await this.asyncGetList(token,"moduleinfo",{condition,limit:10000000,cache,cache_local:cache});
    extra_modules = extra_modules.sort((a,b)=>(a.stt||0)-(b.stt||0));
    //console.log("get module 3");
    // Ghép menu cấu hình với nhóm menu của máy chủ (kể cả mục lõi do module xếp lại) — xem ghepMenu.js.
    ghepMenu(modules, extra_modules);
    //filter companies
    modules = modules.filter(m=>{
      if(m.only_for_companies &&  m.only_for_companies.length>0 && m.only_for_companies.indexOf(id_app)<0){
        return false;
      }
      if(m.not_for_companies &&  m.not_for_companies.length>0 && m.not_for_companies.indexOf(id_app)>=0){
        return false;
      }
      return true;
    }).sort((a,b)=>(a.stt||0)-(b.stt||0));
    //Create menu
    _menu =  modules.map(m=>{
      m.items = m.items ||[]
      m.items.forEach(item=>{
        delete item._id;
        item.module_code = m.code;
        item.module_title = m.title;
        if(!item.group){
          item.group = m.title;
          item.group_code = item.active_require?item.code:"";
        }
        item.stt_module = m.stt;
        item.mother_module = m.mother_module;
        item.name_mother_module = m.name_mother_module;
        if(item.type && !item.path && !item.url && item.type.toLowerCase()!=="other"){
          item.path = "/" + item.type.toLowerCase() + "/" + item.code;
        }
      })
      return m.items;
    }).reduce((a,b)=>a.concat(b),[]);

    _menu = _menu.filter(m=>{
      if(m.only_for_companies &&  m.only_for_companies.length>0 && m.only_for_companies.indexOf(id_app)<0){
        return false;
      }
      if(m.not_for_companies &&  m.not_for_companies.length>0 && m.not_for_companies.indexOf(id_app)>=0){
        return false;
      }
      return true;
    })
    
    //get api_code
    log("Get custom list apis")
    let listinfos =  await this.asyncGetList(token,"listinfo",{cache:cache,cache_local:cache,limit:1000000,condition:{api_code:{$nin:["",null,undefined]}},fields:"code,api_code"});
    log("Get custom report apis")
    let reportInfos =  await this.asyncGetList(token,"reportinfo",{cache:cache,cache_local:cache,limit:1000000,condition:{api_code:{$nin:["",null,undefined]}},fields:"code,api_code"});
    log("handle api code")
    
    _menu.forEach(item=>{
      let linfo = listinfos.find((l)=>{
        return l.code?.toLowerCase() === item.code?.toLowerCase();
      });
      if(!linfo){
        linfo = reportInfos.find((l)=>{
          return l.code?.toLowerCase() === item.code?.toLowerCase();
        });
      }
      
      if(linfo){
        item.api_code = linfo.api_code||item.code;
      }else{
        item.api_code = item.code;
      }
    })
    //
    if(!group){
      if(!userInfo.email){
        log("get user info")
        userInfo = await this.asyncGetUserInfoByToken(token);
      }
      log("get app info")
      const p = await this.asyncGetAppInfo(token,id_app,"name");
      if(!p){
        return {modules:[],menu:[]};
      }
      if(p.appAdmin){
        _menu.forEach(_item => {
          _item.view_all = true;
          _item.view = true;
          _item.viewOfOther = true;
          _item.add = true;
          _item.update = true;
          _item.delete = true;
        });
        return {modules,menu:_menu};
      }else{
        group = p.group_id;
      }
    }
    if(!group) return {modules:[],menu:[]};

    log("get rights")
    const rights = await this.asyncGetList(token,"right",{id_app,cache,cache_local:cache,condition:{email:group},limit:90000});
    _menu.forEach((_item) => {
      let _right = this.config.get("pha_quyen_theo_api_code")?rights.filter(r=>r.module===_item.api_code.toLowerCase()):rights.filter(r=>r.module===_item.code.toLowerCase());
      if(_right.length>0){
        if(_right.length>1) console.error("[APIS][getModel] error multi record",_item.api_code,_right)
        for(let key in _right[0]){
          _item[key] = _right[0][key];
        }
      }else{
        _item.view_all = false;
        _item.view = false;
        _item.viewOfOther = false;
        _item.add = false;
        _item.update = false;
        _item.delete = false;
      }
    });
    return {modules,menu:_menu};
  }
  /**deprecated */
  async asyncGetMenu(userInfo,group,id_app,log=()=>{},cache=false){
    if(!id_app) id_app = this.config.get("id_app");
    let system_code = this.config.get("system_code");
    let menu = this.config.get("menu")||[];
    let modules = this.config.get("modules")||[];
    let token;
    if(isObject(userInfo)){
      token = userInfo.token
    }else{
      token = userInfo;
    }
    if(!token) return [];
    let extra_funcs=[];
    //get menu on server
    if(system_code && !this.config.get("only_use_menu_local")){
      log("Get module info:" + system_code)
      let condition = {app:system_code};
      let extra_modules = await this.asyncGetList(token,"moduleinfo",{condition,limit:100000,cache:cache,cache_local:cache});
      //join with modules in configs
      extra_modules.forEach(module=>{
        let conf_module = modules.find(m=>m.code?.toLowerCase()===module.code?.toLowerCase());
        if(!conf_module){
          modules.push(modules);
        }else{
          conf_module.items = conf_module.items||[];
          (module.items||[]).forEach(item=>{
            if(!conf_module.items.find(c_item=>c_item.code?.toLowerCase()==item.code?.toLowerCase())){
              conf_module.items.push(item);
            }
          })
        }
      })
      //filter companies
      modules = modules.filter(m=>{
        if(m.only_for_companies &&  m.only_for_companies.length>0 && m.only_for_companies.indexOf(id_app)<0){
          return false;
        }
        if(m.not_for_companies &&  m.not_for_companies.length>0 && m.not_for_companies.indexOf(id_app)>=0){
          return false;
        }
        return true;
      })
      extra_funcs = modules.map(m=>{
        return  (m.items||[]).map(item=>{
          delete item._id;
          item.group = m.title;
          item.group_code = item.active_require?item.code:"";
          item.stt_module = m.stt;
          item.mother_module = m.mother_module;
          item.name_mother_module = m.name_mother_module;
          if(item.type && !item.path && !item.url && item.type.toLowerCase()!=="other"){
            
            item.path = "/" + item.type.toLowerCase() + "/" + item.code;
          }
          return item;
        })
      }).reduce((a,b)=>a.concat(b),[]);
    }
    let _menu = cloneDeep(menu).filter(item=>{
      return !extra_funcs.find(i=>i.code?.toLowerCase()===item.code?.toLowerCase() && i.group?.toLowerCase()===item.group?.toLowerCase());
    });
    _menu.forEach(item=>{
      item.stt = item.stt || 0;
      item.stt_module = item.stt_module || item.stt || 99999;
    })
    _menu = [...extra_funcs,..._menu];
    _menu = _menu.sort((a,b)=>a.stt_module-b.stt_module);
    //get api_code
    log("Get custom list apis")
    let listinfos =  await this.asyncGetList(token,"listinfo",{cache:cache,cache_local:cache,limit:1000000,condition:{api_code:{$nin:["",null,undefined]}},fields:"code,api_code"});
    log("Get custom report apis")
    let reportInfos =  await this.asyncGetList(token,"reportinfo",{cache:cache,cache_local:cache,limit:1000000,condition:{api_code:{$nin:["",null,undefined]}},fields:"code,api_code"});
    log("handle api code")
    _menu.forEach(item=>{
      let linfo = listinfos.find((l)=>{
        return l.code?.toLowerCase() === item.code?.toLowerCase();
      });
      if(!linfo){
        linfo = reportInfos.find((l)=>{
          return l.code?.toLowerCase() === item.code?.toLowerCase();
        });
      }
      
      if(linfo){
        item.api_code = linfo.api_code||item.code;
      }else{
        item.api_code = item.code;
      }
    })
    //
    if(!group){
      if(!userInfo.email){
        log("get user info")
        userInfo = await this.asyncGetUserInfoByToken(token);
      }
      log("get app info")
      const p = await this.asyncGetAppInfo(token,id_app,"name");
      if(!p){
        console.error("company is not exists");
        return [];
      }
      if(p.appAdmin){
        return (_menu||[]).map((item) => {
          let _item =  {...item};
          _item.view = true;
          _item.view_all = true;
          _item.viewOfOther = true;
          _item.add = true;
          _item.update = true;
          _item.delete = true;
          return _item;
        });
      }else{
        group = p.group_id;
      }
    }
    if(!group) return [];
    log("get rights")
    const rights = await this.asyncGetList(token,"right",{id_app,cache:cache,cache_local:cache,condition:{email:group},limit:90000});
    return (_menu||[]).map((item) => {
      let _item = {...item};
      let _right = rights.filter(r=>r.module===_item.api_code.toLowerCase());
      if(_right.length>0){
        if(_right.length>1) console.log("error multi record",_item.api_code,_right)
        _item = {..._item,..._right[0]};
      }else{
        _item.view_all = false;
        _item.view = false;
        _item.viewOfOther = false;
        _item.add = false;
        _item.update = false;
        _item.delete = false;
      }
      return _item;
    });
  }
  async asyncUpdateRight(token,value){
    let data = Object.assign({},value);
    return this.asyncPostList(token,"right",data);
  }
  async asyncJoinApp(token,id_app,group_id){
    let url = `${this.config.get("server_url_report")}/api/app/join/${id_app}/${group_id}?access_token=${token}`;
    return this.asyncGet(url);
  }
  /***
   * Backup data of a company — chạy NỀN trên server (dữ liệu lớn có thể mất hàng chục phút).
   *  - callback(error, response): gọi NGAY khi server nhận việc; response = {status:'processing', id_job, message}.
   *  - onDone(error, {download_url, file, ket_qua}): gọi khi backup xong (đã tự mở link tải file) hoặc lỗi.
   *  - onProgress(tien_do): gọi mỗi lần hỏi trạng thái trong lúc chờ ({buoc, collection, so_dong, ...}).
   * Trước đây chỉ gọi 1 request rồi trông vào thông báo: không thấy thông báo là không có kết quả gì.
   */
  async asyncBackup(token,id_app,callback,onDone,onProgress){
    let url = `${this.config.get("server_url_report")}/api/app/backup/${id_app}?access_token=${token}`;
    this.downloadFile(url,"backup.zip",(error,response)=>{
      if(callback) callback(error,response);
      if(!error && response && response.id_job){
        this._theoDoiBackup(token,id_app,response.id_job,onDone,onProgress);
      }
    });
  }
  /** Hỏi trạng thái tác vụ backup tới khi xong/lỗi; xong thì mở link tải file (trình duyệt tự lưu ra đĩa). */
  _theoDoiBackup(token,id_app,id_job,onDone,onProgress){
    const batDau = Date.now();
    const TOI_DA = 12*60*60*1000;   // thôi hỏi sau 12 giờ (thông báo từ server vẫn còn)
    let loiLienTiep = 0;
    const xong = (e,rs)=>{ try{ if(onDone) onDone(e,rs); }catch(e2){ console.error(e2); } };
    const hoi = ()=>{
      // Lấy token HIỆN TẠI (phiên có thể đã được làm mới trong lúc chờ); downloadFile tự xử lý 401.
      const tk = this.getAccessToken() || token;
      const url = `${this.config.get("server_url_report")}/api/app/backup-status/${id_app}?id_job=${encodeURIComponent(id_job)}&access_token=${tk}`;
      this.downloadFile(url,"backup-status.json",(e,st)=>{
        if(e || !st || typeof st!=="object"){
          // Lỗi mạng thoáng qua thì hỏi lại; lỗi liên tục (hoặc phiên hết) thì dừng.
          loiLienTiep++;
          if((e && e.auth_code) || loiLienTiep>=10) return xong(e || {error:"Không hỏi được trạng thái sao lưu"});
          return setTimeout(hoi, 15000);
        }
        loiLienTiep = 0;
        if(st.status==="done" && st.download_url){
          this._moLinkTai(st.download_url, st.file || "backup.zip");
          return xong(null, st);
        }
        if(st.status==="done" || st.status==="error") return xong(st.error ? {error:st.error, message:st.error} : null, st);
        try{ if(onProgress) onProgress(st.tien_do || {}); }catch(e2){ console.error(e2); }
        if(Date.now()-batDau > TOI_DA) return xong({error:"Sao lưu chạy quá lâu — hãy xem thông báo từ hệ thống khi hoàn tất"});
        // Hỏi dày lúc đầu, thưa dần (tối đa 30s/lần) để không tạo tải vô ích khi backup chạy lâu.
        setTimeout(hoi, Math.min(30000, 5000 + Math.floor((Date.now()-batDau)/60000)*5000));
      });
    };
    setTimeout(hoi, 3000);
  }
  /** Tải file lớn bằng LINK TRỰC TIẾP (không qua fetch/blob -> không nạp cả file vài GB vào RAM trình duyệt). */
  _moLinkTai(url, name){
    if(window.ReactNativeWebView && window.download){
      window.download(url, name);
      return;
    }
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.rel = "noopener";
    a.style.display = "none";
    document.body.appendChild(a);
    a.click();
    setTimeout(()=>{ try{ document.body.removeChild(a); }catch(e){ /* bỏ qua */ } }, 1000);
  }
  /***
   * Danh sách file backup có sẵn trên máy chủ dùng được để khôi phục công ty (mới nhất trước):
   * [{file, size, ngay, cua_cong_ty}]. File vài GB nên khôi phục từ đây thay vì tải lên qua trình duyệt.
   */
  async asyncListBackupFiles(token,id_app){
    let url = `${this.config.get("server_url_report")}/api/app/backup-files/${id_app}?access_token=${token}`;
    return this.asyncGet(url);
  }
  /***
   * Khôi phục dữ liệu công ty từ file backup CÓ SẴN trên máy chủ (tên file lấy từ asyncListBackupFiles).
   * callback(error, text) giống asyncRestore: server nhận việc thì trả lời ngay, kết quả gửi qua thông báo.
   */
  async asyncRestoreFromServer(token,id_app,fileName,callback=()=>{}){
    let url = `${this.config.get("server_url_report")}/api/app/restore/${id_app}?access_token=${token}`;
    axios({
      method: "post",
      url: url,
      data: { file_from_server: fileName },
      withCredentials: true,
      headers: Object.assign({"Content-Type": "application/json"}, this._trustHeaders()),
    }).then(response=>{
      let text = (typeof(response.data)=="object"?JSON.stringify(response.data):response.data);
      callback(null,text,response);
    }).catch(e=>{
      let d = (e && e.response && e.response.data) || e;
      if(d && typeof d==="object" && d.error && !d.message) d = Object.assign({}, d, {message:d.error});
      callback(typeof d==="string" ? {message:d} : d);
    });
  }
  /***
   * restore data of a company
   */
  async asyncRestore(token,id_app,fileRaw,callback=()=>{},data={}){
    let url = `${this.config.get("server_url_report")}/api/app/restore/${id_app}?access_token=${token}`;
    data.return = "JSON";
    data["backup"] = fileRaw;
    let formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    axios({
      method: "post",
      url: url,
      data: formData,
      withCredentials: true,
      headers: Object.assign({"Content-Type": "multipart/form-data"}, this._trustHeaders()),
    }).then(response=>{
      let text = (typeof(response.data)=="object"?JSON.stringify(response.data):response.data)
      callback(null,text,response);
    }).catch(e=>{
      let error = (e.response?e.response.data:e) || e
      //console.error("Error get data:",error);
      callback(error);
    })
    /*fetch(url, {method: "POST", body: formData}).then( response => {
      response.text().then((text)=>{
        if(response.ok) {
          callback(null,text);
        }else{
          try{
            if(typeof(text)!=="object"){
              if(text.indexOf("{")===0){
                text = JSON.parse(text)
              }else{
                text ={message:text,code:400}
              }
            }
          }catch(e){
            text ={message:text,code:400}
          }
          if(text.error && !text.message){
            text.message = text.error;
          }
          callback(text);
        }
      })
    })
    .catch(e=>callback(e))*/
  }
  /***
   * data require fields:_id,code,time_run,users_will_receive,title,repeat(option),finish_run(option)
   */
  async addNotifySchedule(token,data){
    data.id_app = this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/schedule/add/notify?access_token=${token}`;
    return this.asyncPost(url,null,data,"POST","POST",false);
  }
  async deleteNotifySchedule(token,id_link){
    let url = `${this.config.get("server_url_report")}/api/schedule/delete/${id_link}?access_token=${token}`;
    return this.asyncGet(url);
  }
  /***
   * data require fields:time_run,data._id,data.id_app,data.module
   */
  async addSchedule(type,token,data){
    data.id_app = this.config.get("id_app");
    let url = `${this.config.get("server_url_report")}/api/schedule/add/${type}?access_token=${token}`;
    return this.asyncPost(url,null,data,"POST","POST",false);
  }
  async deleteSchedule(token,id_link){
    let url = `${this.config.get("server_url_report")}/api/schedule/delete/${id_link}?access_token=${token}`;
    return this.asyncGet(url);
  }

  async asyncTinhChietKhauHD(access_token,data,tong_tien_tinh_ck=0,options={}){
    options.stringifyData = false;
    let _id_app =(options.id_app || data.id_app ||this.config.get("id_app"));
    let url = `${this.config.get("server_url_report")}/api/${_id_app}/dmchietkhauhd/tinhchietkhau/` + tong_tien_tinh_ck ;
    let method ="POST";
    url = `${url}?access_token=${access_token}`;
    return await this.asyncPost(url,null,data,method,method,false,options);
  }
  async getPromotion(access_token,obj,detail,product=undefined,ma_ct=undefined){
    
    let item = detail;
    if(item.km_yn_for) return;
    let km_yn_for = `${item.ma_vt}-${item.ma_tt1||""}-${item.ma_tt2||""}-${item.ma_tt3||""}`;
    obj.details = obj.details.filter(d=>d.km_yn_for!==km_yn_for);
    obj.details.forEach(d=>{
      d.sl_xuat_qd = d.sl_xuat_qd||d.sl_xuat||0;
    })
    
    let _id_app =(obj.id_app ||this.config.get("id_app"));

    let t_sl = obj.details.filter(d=>d.ma_nvt===detail.ma_nvt && !d.km_yn_for).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
    let t_sl_ntt = obj.details.filter(d=>d.nh_tt===detail.nh_tt && !d.km_yn_for).map(d=>d.sl_xuat_qd||0).reduce((a,b)=>a+b,0);
    let t_tien_ntt = obj.details.filter(d=>d.nh_tt===detail.nh_tt && !d.km_yn_for).map(d=>d.tien_ct_nt||d.tien_hang_ct_nt||0).reduce((a,b)=>a+b,0);

    //console.log("get promotion",{obj,detail,product,ma_ct,t_sl,t_sl_ntt,t_tien_ntt});

    let condition={
      id_app:_id_app,
      ma_vt:detail.ma_vt,
      ma_tt1:detail.ma_tt1,
      gia_theo_kh:true,
      so_luong:detail.sl_xuat_qd,
      t_sl,
      t_sl_ntt,
      t_tien_ntt,
      
      get_price:false,
      get_promotion:true,
      get_discount:false,
      get_properties:false,
      ma_ct
    }
    //console.log("get promotion",condition);
    let products = await this.asyncGetList(access_token,"dmvt",{condition,fields:"ma_vt,ma_dvt,gia_ban_le,ma_nt0,ma_nt,ma_nvt,ma_nvt2,ma_nvt3,ma_nvt4",limit:1});
    if(products.length>0){
      product = products[0]
    }
    if(!product) return;
    let current_time = new Date().getTime();
    //console.log("promotion",ma_ct,product.default_promotion);
    if(product.default_promotion){
      product.default_promotion.forEach((promotion,index_p)=>{
        //console.log(promotion);
        //console.log({details_km:promotion.details_km});
        for(let index=0;index<(promotion.details_km||[]).length;index++){
          let detail_km = promotion.details_km[index];
          //console.log(detail_km);
          let sl_km = detail_km.sl_km;
          let id_cs;
          if(sl_km){
            if(promotion.sl_tu && promotion.sl_den && promotion.sl_tu==promotion.sl_den && item.sl_xuat_qd>promotion.sl_tu){
              sl_km = Math.floor(item.sl_xuat_qd/promotion.sl_tu) * sl_km;
            }
            id_cs = promotion.id_cs||promotion._id;
            obj.details.push({
              ma_vt:detail_km.ma_vt,
              ten_vt:detail_km.ten_vt,
              ma_dvt:detail_km.ma_dvt,
              ma_tt1:detail_km.ma_tt1,
              thuoc_tinh:detail_km.thuoc_tinh,
              gia_ban_nt: 0,
              sl_xuat: sl_km,
              tien_ct_nt:0,
              tien_ct:0,
              tien_nt:0,
              tien:0,
              tien_thue_nt:0,
              tien_thue:0,
              tien_ck_nt:0,
              tien_ck:0,
              line: current_time + index_p + index + 1,
              km_yn_for,
              id_cs
            })
          }
        }
      })
    }
    
  }
}